import React, { useState, useRef, useEffect } from "react";
import styles from "./BusinessStep.module.css";
import NewModal from "../NewModal/NewModal";
import AnimatedButton from "../AnimatedButton/AnimatedButton";
import AgentCreationLoader from "../AgentCreationLoader/AgentCreationLoader";
import StepOne from "./StepOne";
import StepTwo from "./StepTwo";
import StepThree, { defaultLanguage } from "./StepThree";
import StepPhoneLookup from "./StepPhoneLookup";
import StepNameZip from "./StepNameZip";
import ExitConfirmModal from "../ExitConfirmModal/ExitConfirmModal";
import PouncePlanScreen from "../PouncePlan/PouncePlanScreen";
import PounceQualifyingQuestions, {
  DEFAULT_POUNCE_QUALIFYING_QUESTIONS,
} from "../PouncePlan/PounceQualifyingQuestions";
import NewAgentPlanScreen from "./NewAgentPlanScreen";
import { isNativeApp } from "../../utils/nativePermissions";
import { useLocation, useNavigate } from "react-router-dom";
import { secureStorage } from "../../utils/secureStorage";
import {
  pyOrNodeUrl,
  authHeaders,
  isPythonBackend,
  isIndiaSite,
  isAppSumoUser,
  usesElevenLabs,
} from "../../utils/apiBackend";
import {
  createChatAgent,
  getOnBoardingTracker,
  savePouncePlan,
  startPounceCheckout,
  findPaidPounceSetup,
} from "../../Store/apiStore";
import { useCheckoutStore } from "../../Store/checkoutStore";
import { useDashboardStore } from "../../Store/agentZustandStore";
import useOnboardingTracker from "../../hooks/useOnboardingTracker";
import { trackEvent, setUserProperties } from "../../lib/analytics";
import { markSetupStep } from "../../lib/setupScore";
import decodeToken from "../../lib/decodeToken";
import PopUp from "../Popup/Popup";
import axios from "axios";
import getTimezoneFromState from "../../lib/timeZone";
import { getAgentsByUserIdforkey, listSiteMap } from "../../Store/apiStore";
import filterCompanyPages from "../../utils/companyKeyboards";
import { businessServices } from "../../lib/businessServices";
import { requiresCallRecording } from "../../lib/callRecordingStates";
import detectPlatform from "../../utils/detectPlatform";
import {
  ONBOARDING_RESUME_KEYS,
  saveResumeRoute,
  saveResumeSnapshot,
  getResumeSnapshot,
  clearOnboardingResume,
} from "../../utils/onboardingResume";
const STEP_FLOW = [1, 2, 3, 4, 5];
const BUSINESS_EMAIL_MAX_LENGTH = 40;


// Same 9-6 fallback StepTwo uses when Google has no opening hours for a place.
const DEFAULT_HOURS_STRING = [
  "Monday: 9:00 AM – 6:00 PM",
  "Tuesday: 9:00 AM – 6:00 PM",
  "Wednesday: 9:00 AM – 6:00 PM",
  "Thursday: 9:00 AM – 6:00 PM",
  "Friday: 9:00 AM – 6:00 PM",
  "Saturday: 9:00 AM – 6:00 PM",
  "Sunday: Closed",
].join(" | ");

/*
 * secureStorage.get() returns its DEFAULT ({} / []) when the key is missing,
 * and `{}`/`[]` are truthy — so `secureStorage.get(k, {}) || formData.x` never
 * reached the fallback. Any dropped/failed write therefore built the createAgent
 * payload with an empty business name, phone and address while the confirm
 * modal on screen still showed the right values. Fall back on EMPTY, not just
 * on nullish.
 */
const firstNonEmpty = (...candidates) => {
  for (const c of candidates) {
    if (Array.isArray(c)) {
      if (c.length) return c;
      continue;
    }
    if (c && typeof c === "object") {
      if (Object.keys(c).length) return c;
      continue;
    }
    if (c) return c;
  }
  return undefined;
};

/*
 * Pounce "Use existing business details" (More menu → FooterNew).
 *
 * Business steps is flow me dikhte hi nahi, isliye maujooda business ko unhi
 * secureStorage keys me daal dete hain jo buildFinalPayload padhta hai — aage
 * ka qualifying → plan → card → createAgent rasta "new business" jaisa hi hai.
 * Yahi keys Back / exit pe saaf hoti hain.
 */
const POUNCE_EXISTING_KEYS = [
  "currentStep",
  "businessType",
  "businessSubtype",
  "customBusiness",
  "displayBusinessName",
  "googleListing",
  "businessUrl",
  "placeDetailsExtract",
  "selectedSiteMapUrls",
  "urls",
  "aboutBusinessForm",
  "agentLanguage",
  "agentLanguageCode",
  "customGreeting",
  "greetingChoice",
  "customGreetingText",
  "timezone",
  "pouncePlan",
  "pouncePlanOpen",
  "pounceOnboardingId",
  "pouncePaidDone",
  "pounceQualifyingQuestions",
  "pounceQualifyingOpen",
];
// DB JSON columns kabhi string ban ke aate hain.
const parseMaybeJson = (value, fallback) => {
  if (typeof value !== "string") return value ?? fallback;
  try {
    return JSON.parse(value) ?? fallback;
  } catch {
    return fallback;
  }
};
const seedPounceExistingBusiness = ({ business = {}, agent = {} } = {}) => {
  POUNCE_EXISTING_KEYS.forEach((key) => secureStorage.remove(key));

  // knowledge_base_texts = wahi addressDetails jo is business ke createAgent
  // me gaya tha (+ hours) — yani original placeDetails.
  const kb = parseMaybeJson(business.knowledge_base_texts, {}) || {};
  const savedDetails = Array.isArray(kb) ? {} : kb;
  const businessName =
    business.businessName ||
    business.googleBusinessName ||
    savedDetails.businessName ||
    "";
  const placeDetails = {
    ...savedDetails,
    businessName,
    phone: savedDetails.phone || business.phone || "",
    internationalPhone: savedDetails.internationalPhone || business.phone || "",
    email: savedDetails.email || business.buisnessEmail || "",
    address:
      savedDetails.address ||
      savedDetails.formattedAddress ||
      business.address1 ||
      "",
    city: savedDetails.city || business.city || "",
    state: savedDetails.state || business.state || "",
    country: savedDetails.country || business.country || "",
    postalCode: savedDetails.postalCode || business.zip || "",
    country_code: savedDetails.country_code || business.country_code || "",
  };
  const scrapedUrls = parseMaybeJson(business.scrapedUrls, []);

  secureStorage.set("placeDetailsExtract", placeDetails);
  secureStorage.set("displayBusinessName", businessName);
  if (business.businessType) secureStorage.set("businessType", business.businessType);
  if (business.subType) secureStorage.set("businessSubtype", business.subType);
  if (business.googleUrl) secureStorage.set("googleListing", business.googleUrl);
  if (business.webUrl) secureStorage.set("businessUrl", business.webUrl);
  if (Array.isArray(scrapedUrls) && scrapedUrls.length) {
    secureStorage.set("selectedSiteMapUrls", scrapedUrls);
  }
  if (agent.agentLanguage) secureStorage.set("agentLanguage", agent.agentLanguage);
  if (agent.agentLanguageCode) {
    secureStorage.set("agentLanguageCode", agent.agentLanguageCode);
  }
  if (agent.timezone) secureStorage.set("timezone", { timezoneId: agent.timezone });
  // Last step pe: wahi se pouncePaid return agent banata hai.
  secureStorage.set("currentStep", 5);
  secureStorage.set("pounceQualifyingOpen", true);
  // Checkout isi business pe subscription banata hai.
  if (business.businessId) {
    sessionStorage.setItem("SelectAgentBusinessId", business.businessId);
  }
};

// Truncate long confirm-modal values with a trailing ellipsis.
const truncateText = (text, max = 20) => {
  const s = String(text ?? "");
  return s.length > max ? `${s.slice(0, max)}...` : s;
};
const BusinessStep = () => {
  const totalSteps = 5;
  const navigate = useNavigate();

  const FEMALE_AGENT_NAMES = [
    // Previous 20
    "Emma",
    "Mia",
    "Ava",
    "Nora",
    "Maya",
    "Amy",
    "Lisa",
    "Kate",
    "Anna",
    "Ella",
    "Grace",
    "Lucy",
    "Bella",
    "Iris",
    "Sara",
    "Layla",
    "Clara",
    "Nadia",
    "Tania",
    "Lydia",
    "Sophia",
    "Olivia",
    "Sasha",
    "Amelia",
    "Harper",
    "Evelyn",
    "Abigail",
    "Emily",
    "Sasha",
    "Chloe",
    "Lily",
  ];

  // The India site needs Indian names: an agent introducing itself as
  // "Harper" while speaking Hindi reads as a foreign call centre, which is
  // the opposite of what a local receptionist should sound like. The voices
  // are unchanged — this is only the name the agent gives on the call.
  const INDIA_FEMALE_AGENT_NAMES = [
    "Aditi",
    "Ananya",
    "Anjali",
    "Diya",
    "Ishita",
    "Kavya",
    "Meera",
    "Naina",
    "Neha",
    "Nisha",
    "Pooja",
    "Priya",
    "Riya",
    "Saanvi",
    "Sanya",
    "Simran",
    "Sneha",
    "Tara",
    "Aarohi",
    "Kiara",
  ];

  const getRandomAgentName = () => {
    const pool = isIndiaSite() ? INDIA_FEMALE_AGENT_NAMES : FEMALE_AGENT_NAMES;
    return pool[Math.floor(Math.random() * pool.length)];
  };

  /*
   * Naye agent ka avatar. Pehle har agent ko hardcoded Female-07.png milti
   * thi — ab public/images/ me padi in gyarah me se koi ek.
   *
   * Path public/ ke andar se relative hai (jaise pehle tha), isliye yahan
   * import nahi kar rahe — ye string seedha backend ko jaati hai aur wahin
   * store hoti hai.
   *
   * Poori list JAAN-BOOJH KE likhi hai, generate nahi ki. Pehle
   * `Array.from({length: N}, (_, i) => \`Female-0${i + 1}.png\`)` tha, jo 09
   * tak to theek chalta haiff par ufffske aage padding tod deta hai — 10 aur 11
   * ke liye wo "Female-010.png" / "Female-011.png" banata hai, jo files
   * exist hi nahi karti. Nayi image add karni ho to bas ek line yahan jodo.
   */
  const FEMALE_AGENT_AVATARS = [
    "images/Female-01.png",
    "images/Female-02.png",
    "images/Female-03.png",
    "images/Female-04.png",
    "images/Female-05.png",
    "images/Female-06.png",
    "images/Female-07.png",
    "images/Female-08.png",
    "images/Female-09.png",
    "images/Female-10.png",
    "images/Female-11.png",
    "images/Female-12.png",
    "images/Female-13.png",
    "images/Female-14.png",
    "images/Female-16.png",
  ];

  const getRandomAgentAvatar = () => {
    return FEMALE_AGENT_AVATARS[
      Math.floor(Math.random() * FEMALE_AGENT_AVATARS.length)
    ];
  };

  // User info
  const token = localStorage.getItem("token") || "";
  const decodedToken = decodeToken(token) || {};
  const teamOwnerId = typeof window !== "undefined" ? localStorage.getItem("teamOwnerId") : null;
  const userId = teamOwnerId || decodedToken.ownerId || decodedToken.id || "";
  const email = localStorage.getItem("userEmail") || "";

  // Tracker hook
  const { trackStep } = useOnboardingTracker();
  const [randomAgentName] = useState(() => getRandomAgentName());
  /*
   * useState (seedha getRandomAgentAvatar() nahi) — bilkul naam wali tarah.
   * Har render pe naya call hota to onboarding ke beech avatar badalta
   * rehta, aur do alag payload branches ko do alag avatar mil jaate. Lazy
   * initializer se ek hi baar chunta hai aur poore flow me wahi rehta hai.
   */
  const [randomAgentAvatar] = useState(() => getRandomAgentAvatar());
  // Step state
  const [step, setStep] = useState(1);
  const [nextStep, setNextStep] = useState(null);
  const [direction, setDirection] = useState("forward");
  const [isAnimating, setIsAnimating] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showDetailedForm, setShowDetailedForm] = useState(false);
  // Step 2: after a zip is picked + Continue, show the Google Business Listing
  // confirmation screen (replaces the footer with an "Enter manually" footer).
  const [showListingConfirm, setShowListingConfirm] = useState(false);
  // "Enter manually?" confirmation popup (before switching to the manual form).
  const [showManualConfirm, setShowManualConfirm] = useState(false);
  const [completedSteps, setCompletedSteps] = useState([]);
  /*
   * "Category screen (step 3) is journey me dikhi thi" — ek baar TRUE hone ke
   * baad TIKTA hai, jab tak flow dobara shuru na ho.
   *
   * completedSteps par bharosa nahi kar sakte: peeche jaane par wo trim ho
   * jata hai (resetFromStep me `completedSteps.filter(s => s <= fromStep)`).
   * Isliye user ke dots se aage-peeche karne par 3 nikal jata tha aur dots
   * 3 se 2 ho jate the — chahe user ne category khud select ki ho.
   */
  const [categoryScreenShown, setCategoryScreenShown] = useState(
    () => secureStorage.get("categoryScreenShown", false) === true,
  );
  const [isInitialized, setIsInitialized] = useState(false);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  /*
   * Pounce flow — More menu → "Faster Conversions" → "Add new business
   * details" se aata hai (state.flow = "pounce").
   *
   * sessionStorage me bhi rakhte hain: refresh aur Stripe ka 3DS redirect
   * router state gira dete hain, aur tab ye user receptionist flow me gir
   * jaata. Jab router state AAYI ho (explicit entry) tabhi flag likhte/mitaate
   * hain — isliye receptionist ka "new agent" entry purana pounce flag saaf
   * kar deta hai.
   */
  const [isPounceFlow] = useState(() => {
    try {
      if (location?.state) {
        if (location.state.flow === "pounce") {
          sessionStorage.setItem("onboardingFlow", "pounce");
        } else {
          sessionStorage.removeItem("onboardingFlow");
        }
      }
      return sessionStorage.getItem("onboardingFlow") === "pounce";
    } catch {
      return location?.state?.flow === "pounce";
    }
  });
  // Plan + card screen (sirf Pounce). secureStorage me isliye ki 3DS redirect
  // se lautne pe user wapas isi screen pe aaye.
  /*
   * "Naya agent banao" ka explicit intent — Create button / Add Agent se
   * state.mode = "new" aata hai. Jiske paas pehle se agent hai use neeche wala
   * redirect /fast-agent-detail bhej deta tha, to wo doosra agent bana hi nahi
   * pata tha. Intent ho to redirect skip.
   *
   * sessionStorage me isliye ki onboarding ke beech refresh pe router state
   * chali jaati hai. Agent ban jaane pe flag hat jaata hai; bina intent ke
   * /business-step pe aaya purane agent wala user pehle ki tarah hi wapas jaata hai.
   */
  const [isAddingAgent] = useState(() => {
    try {
      if (location?.state) {
        if (location.state.mode === "new") {
          sessionStorage.setItem("addingAgent", "1");
        } else {
          sessionStorage.removeItem("addingAgent");
        }
      }
      return sessionStorage.getItem("addingAgent") === "1";
    } catch {
      return location?.state?.mode === "new";
    }
  });
  /*
   * Pounce "Use existing business details" — More menu se state.mode =
   * "existing" + business aata hai. Business steps skip: business seed karke
   * seedha qualifying questions. Value = wo route jahan se user aaya tha;
   * qualifying screen ka Back wahi le jaata hai. sessionStorage me isliye ki
   * Stripe ka hosted redirect router state gira deta hai.
   */
  const [pounceExistingReturnTo] = useState(() => {
    try {
      if (location?.state) {
        if (
          location.state.flow === "pounce" &&
          location.state.mode === "existing"
        ) {
          seedPounceExistingBusiness(location.state);
          sessionStorage.setItem(
            "pounceExistingReturnTo",
            location.state.returnTo || "/fast-agent-detail",
          );
        } else {
          sessionStorage.removeItem("pounceExistingReturnTo");
        }
      }
      return isPounceFlow
        ? sessionStorage.getItem("pounceExistingReturnTo") || ""
        : "";
    } catch {
      return "";
    }
  });
  const exitPounceExisting = () => {
    POUNCE_EXISTING_KEYS.forEach((key) => secureStorage.remove(key));
    sessionStorage.removeItem("onboardingFlow");
    sessionStorage.removeItem("onboardingMode");
    sessionStorage.removeItem("pounceExistingReturnTo");
    navigate(pounceExistingReturnTo, { replace: true });
  };
  // Pounce: qualifying questions screen (step 5 ke baad, plan se pehle)
  const [showPounceQualifying, setShowPounceQualifying] = useState(
    () =>
      isPounceFlow &&
      (!location?.state || !!pounceExistingReturnTo) &&
      secureStorage.get("pounceQualifyingOpen", false) === true,
  );
  const openPounceQualifying = (open) => {
    setShowPounceQualifying(open);
    if (open) secureStorage.set("pounceQualifyingOpen", true);
    else secureStorage.remove("pounceQualifyingOpen");
  };
  // Fresh entry (router state maujood) hamesha step 1 se — purana flag nahi.
  const [showPouncePlan, setShowPouncePlan] = useState(
    () =>
      isPounceFlow &&
      !location?.state &&
      secureStorage.get("pouncePlanOpen", false) === true,
  );
  const openPouncePlan = (open) => {
    setShowPouncePlan(open);
    if (open) secureStorage.set("pouncePlanOpen", true);
    else secureStorage.remove("pouncePlanOpen");
  };
  /*
   * Receptionist plan screen — jab user ke paas pehle se agent hai aur wo ek
   * AUR receptionist bana raha hai: pehle plan + payment, phir agent (Pounce
   * jaisa). Stripe se lautne pe (hosted redirect = page reload) isi screen
   * ka state wapas chahiye, isliye secureStorage.
   */
  const [showReceptionistPlan, setShowReceptionistPlan] = useState(
    () =>
      !isPounceFlow &&
      !location?.state &&
      secureStorage.get("receptionistPlanOpen", false) === true,
  );
  const openReceptionistPlan = (open) => {
    setShowReceptionistPlan(open);
    if (open) secureStorage.set("receptionistPlanOpen", true);
    else secureStorage.remove("receptionistPlanOpen");
  };
  // Payment ho chuka — buildFinalPayload aur post-create navigation isi se
  // jaante hain ki ye pre-paid naya agent hai (ref, taaki usi tick me dikhe).
  const paidForNewAgentRef = useRef(false);
  const [isAgentAlreadyCreated, setIsAgentAlreadyCreated] = useState(false);
  // Dedicated flag for the full-screen "Creating your Custom AI Receptionist"
  // loader. It must show ONLY during the actual create-agent action — NOT
  // whenever generic `loading` is true on step 3 (e.g. the mount-time agent
  // count check), which made the loader flash when resuming onto step 3.
  const [isCreatingAgent, setIsCreatingAgent] = useState(false);
  const [agentCount, setAgentCount] = useState();
  // Inline validation error for the Business Email field inside the
  // "Confirm your business details" popup.
  const [confirmEmailError, setConfirmEmailError] = useState("");
  // Which confirm-modal row's tooltip is open (click to toggle): 'name' | 'address' | null.
  const [openTip, setOpenTip] = useState(null);
  const modalConfirmedRef = useRef(false);
  const justSelectedGMBRef = useRef(false);
  // True while the confirm modal was opened from a "Use this" listing pick —
  // closing it via the cross should send the user back to step 2.
  const fromListingRef = useRef(false);
  //  GLOBAL PROCESSING STATE - Locks entire UI during async operations
  const [isProcessing, setIsProcessing] = useState(false);
  // True while a "Use this" listing's details are still being fetched —
  // the confirm modal opens immediately and shows a shimmer until done.
  const [listingDetailsLoading, setListingDetailsLoading] = useState(false);

  // Popup
  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState("success");
  const [popupMessage, setPopupMessage] = useState("");
  // Set only for the AppSumo grant popup, so the auto-dismiss below never
  // touches the validation-error popups that share this same PopUp.
  const [autoClosePopup, setAutoClosePopup] = useState(false);
  const [showExitModal, setShowExitModal] = useState(false);

  /*
   * AppSumo grant, announced here rather than on a screen of its own.
   *
   * The redeem screen used to end on a "You're all set — 300 minutes added"
   * page the user had to read and dismiss. It now sends them straight here
   * and leaves the news in sessionStorage, so the confirmation arrives while
   * they are already getting on with setup.
   *
   * Removed as soon as it is read — this is a one-off announcement, not a
   * fact about the account, and it must not reappear on every later visit.
   */
  useEffect(() => {
    let stashed;
    try {
      stashed = sessionStorage.getItem("appsumoRedeemed");
      if (stashed) sessionStorage.removeItem("appsumoRedeemed");
    } catch {
      return;
    }
    if (!stashed) return;

    try {
      const { minutes, planName } = JSON.parse(stashed);
      if (!minutes) return;
      setPopupType("success");
      setPopupMessage(
        `${planName || "Your AppSumo plan"} is active — ${minutes} call minutes added to your account.`,
      );
      setShowPopup(true);
      setAutoClosePopup(true);
    } catch {
      /* unreadable stash — nothing worth showing */
    }
  }, []);

  /*
   * Auto-dismiss for the AppSumo popup above.
   *
   * The timer deliberately does NOT live in that effect. It reads the stash
   * and clears it on the first run, so under StrictMode's double-mount the
   * second run finds nothing, returns early, and its cleanup cancels the
   * timer the first run had started — the popup then sits there forever.
   * Keyed off the flag instead, it survives that remount.
   *
   * Only this popup auto-closes: PopUp is shared with the validation errors
   * below, and those must stay up until they are read.
   */
  useEffect(() => {
    if (!autoClosePopup || !showPopup) return;
    const dismiss = setTimeout(() => {
      setShowPopup(false);
      setAutoClosePopup(false);
    }, 5000);
    return () => clearTimeout(dismiss);
  }, [autoClosePopup, showPopup]);

  // Slide-in error toast (e.g. "Please select a category first.")
  const [categoryError, setCategoryError] = useState(false);
  const categoryErrorTimer = useRef(null);
  const triggerCategoryError = () => {
    setCategoryError(true);
    if (categoryErrorTimer.current) clearTimeout(categoryErrorTimer.current);
    categoryErrorTimer.current = setTimeout(
      () => setCategoryError(false),
      2800,
    );
  };
  useEffect(
    () => () => {
      if (categoryErrorTimer.current) clearTimeout(categoryErrorTimer.current);
    },
    [],
  );

  // Timezone state
  const [timezone, setTimezone] = useState(null);

  // Refs for validation
  const stepPhoneLookupRef = useRef(null);
  const stepNameZipRef = useRef(null);
  const stepCategoryRef = useRef(null);
  const stepServicesRef = useRef(null);
  const stepVoiceRef = useRef(null);
  // console.log(location?.state?.mode, "location?.state?.mode")
  // Form data - centralized state
  const [formData, setFormData] = useState({
    // Step 1
    businessType: "",
    customBusiness: "",
    businessSubtype: "",

    // Step 2
    displayBusinessName: "",
    googleListing: "",
    noGoogleListing: false,
    businessUrl: "",
    noBusinessWebsite: false,
    placeDetails: null,
    sitemapUrls: [],
    selectedSitemapUrls: [],

    // Step 3
    agentLanguage: defaultLanguage().name,
    agentLanguageCode: defaultLanguage().locale,
    agentRole: "General Receptionist",
    agentName: randomAgentName,
    // Greeting (Screen 5). `customGreeting` = jo line actually agent ko jaati
    // hai; baaki do sirf UI ka selection wapas restore karne ke liye hain.
    customGreeting: "",
    greetingChoice: 0,
    customGreetingText: "",
    isGMBSelected: false,
  });
  useEffect(() => {
    const loadData = async () => {
      if (!userId) {
        setIsInitialized(true);
        return;
      }

      /*
       * Cross-reopen restore. secureStorage is sessionStorage-backed,
       * so a full app/browser reopen wipes it. If we kept a localStorage
       * snapshot from the user's previous visit, rehydrate secureStorage
       * from it BEFORE the resume logic below reads any keys — this is
       * what lets Continue Setup land on the exact step with the user's
       * earlier selections intact. We only restore when secureStorage is
       * actually empty (true reopen); a live same-session state always
       * wins. Skipped for the "new" (discard / create fresh) mode, which
       * must start blank.
       */
      const incomingMode =
        location?.state?.mode || sessionStorage.getItem("onboardingMode") || "";
      const isFreshStart =
        incomingMode === "new" ||
        incomingMode === "fresh" ||
        incomingMode === "create";
      /*
       * Gate the restore on `currentStep` ONLY — not businessType.
       *
       * handleDraftContinue runs loadAndHydrateOnboardingTracker before
       * navigating here, and that writes a few sessionStorage keys
       * (businessType, displayBusinessName, …) from the tracker — but it
       * never writes `currentStep`. If we also keyed off businessType,
       * the restore would be skipped (businessType already present), so
       * the snapshot's currentStep=3 never got applied and resume fell
       * back to lastCompleted+1 = step 2. `currentStep` is the reliable
       * "true reopen vs live same-session" signal: absent on a fresh
       * reopen (sessionStorage cleared), present once the user navigates
       * steps in a live session.
       */
      if (!isFreshStart && !secureStorage.has("currentStep")) {
        try {
          const snap = getResumeSnapshot();
          if (snap?.keys) {
            Object.entries(snap.keys).forEach(([k, v]) => {
              if (v !== null && v !== undefined) secureStorage.set(k, v);
            });
          }
        } catch (_e) {
          /* best effort — fall through to normal resume */
        }
      }

      const routerMode = location?.state?.mode;

      if (routerMode) {
        sessionStorage.setItem("onboardingMode", routerMode);
      }
      const mode = routerMode || sessionStorage.getItem("onboardingMode") || "";

      const isResumeMode = mode === "resume";
      const isNewMode = mode === "new" || mode === "fresh" || mode === "create";

      // 🆕 NEW AGENT - Clear everything
      if (isNewMode) {
        setFormData({
          businessType: "",
          customBusiness: "",
          businessSubtype: "",
          displayBusinessName: "",
          googleListing: "",
          noGoogleListing: false,
          businessUrl: "",
          noBusinessWebsite: false,
          placeDetails: null,
          sitemapUrls: [],
          selectedSitemapUrls: [],
          agentLanguage: defaultLanguage().name,
          agentLanguageCode: defaultLanguage().locale,
          agentRole: "General Receptionist",
          agentName: randomAgentName,
          customGreeting: "",
          greetingChoice: 0,
          customGreetingText: "",
          isGMBSelected: false,
          categoryAutoPicked: false,
        });

        const keysToRemove = [
          "currentStep",
          "businessType",
          "businessSubtype",
          "customBusiness",
          "displayBusinessName",
          "googleListing",
          "businessUrl",
          "websiteValidatedUrl",
          "placeDetailsExtract",
          "selectedSiteMapUrls",
          "selectedSiteMapUrls_backup",
          "urls",
          "viewSiteMap",
          "aboutBusinessForm",
          "showNoGMBCheckbox",
          "agentLanguage",
          "agentLanguageCode",
          "agentRole",
          "agentName",
          "customGreeting",
          "greetingChoice",
          "customGreetingText",
          "timezone",
          "lastAgentSessionId",
          "categoryAutoPicked",
          // Warna naya agent pichhli journey ke 3 dots inherit kar leta.
          "categoryScreenShown",
          // Pounce plan and qualifying screen state — naya flow purani choice na le.
          "pouncePlan",
          "pouncePlanOpen",
          "pounceOnboardingId",
          "pouncePaidDone",
          "pounceQualifyingQuestions",
          "pounceQualifyingOpen",
          "receptionistPlanOpen",
          // NOTE: "newAgentPaid" jaan-boojh ke yahan NAHI — paid-but-not-created
          // user naya flow shuru kare to bhi uska payment na khoye; agla bana
          // agent createAgent ke claim se wahi plan le leta hai.
        ];
        keysToRemove.forEach((key) => secureStorage.remove(key));
        sessionStorage.removeItem("onboardingMode");
        // Fresh start — drop any persisted resume backup too.
        clearOnboardingResume();

        const newSessionId = `agent_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        secureStorage.set("currentAgentSessionId", newSessionId);

        setStep(1);
        setCompletedSteps([]);
        setIsInitialized(true);
        return;
      }

      // 🔄 NO MODE - Restore from secureStorage (after refresh)
      if (!isResumeMode && !isNewMode) {
        const savedStep = parseInt(secureStorage.get("currentStep", "1"));
        const hasStoredData = !!(
          secureStorage.get("businessType", "") ||
          secureStorage.get("displayBusinessName", "") ||
          secureStorage.get("placeDetailsExtract", null)
        );

        if (hasStoredData) {
          const resumeStep =
            savedStep >= 1 && savedStep <= totalSteps ? savedStep : 1;

          const placeDetails = secureStorage.get("placeDetailsExtract", null);
          const aboutForm = secureStorage.get("aboutBusinessForm", {});

          // Step 5 (Language & Voice) only needs a business to have been
          // selected in step 4 — a website is optional.
          const hasStep5Access = !!(
            placeDetails?.businessName ||
            secureStorage.get("displayBusinessName", "")
          );

          let safeStep = resumeStep;
          if (resumeStep === 5 && !hasStep5Access) {
            safeStep = 4;
            secureStorage.set("currentStep", 4);
          }

          // ✅ safeStep use karo
          setStep(safeStep);

          // Hydrate formData
          const storedData = {
            businessType: secureStorage.get("businessType", ""),
            businessSubtype: secureStorage.get("businessSubtype", ""),
            customBusiness: secureStorage.get("customBusiness", ""),
            displayBusinessName: secureStorage.get("displayBusinessName", ""),
            googleListing: secureStorage.get("googleListing", ""),
            businessUrl: secureStorage.get("businessUrl", ""),
            placeDetails: placeDetails,
            sitemapUrls: secureStorage.get("urls", []),
            selectedSitemapUrls: secureStorage.get("selectedSiteMapUrls", []),
            agentLanguage: secureStorage.get(
              "agentLanguage",
              defaultLanguage().name,
            ),
            agentLanguageCode: secureStorage.get(
              "agentLanguageCode",
              defaultLanguage().locale,
            ),
            agentRole: secureStorage.get("agentRole", "General Receptionist"),
            agentName: secureStorage.get("agentName", randomAgentName),
            customGreeting: secureStorage.get("customGreeting", ""),
            greetingChoice: secureStorage.get("greetingChoice", 0),
            customGreetingText: secureStorage.get("customGreetingText", ""),
            categoryAutoPicked: secureStorage.get("categoryAutoPicked", false),
          };

          if (typeof aboutForm.noGoogleListing === "boolean") {
            storedData.noGoogleListing = aboutForm.noGoogleListing;
          }
          if (typeof aboutForm.noBusinessWebsite === "boolean") {
            storedData.noBusinessWebsite = aboutForm.noBusinessWebsite;
          }

          const cleanedData = Object.fromEntries(
            Object.entries(storedData).filter(([_, v]) => {
              if (v === null || v === undefined || v === "") return false;
              if (Array.isArray(v) && v.length === 0) return false;
              return true;
            }),
          );

          setFormData((prev) => ({ ...prev, ...cleanedData }));

          // ✅ completedSteps safeStep se rebuild
          const completed = [];
          for (let i = 1; i < safeStep; i++) completed.push(i);
          setCompletedSteps(completed);

          // ✅ showDetailedForm restore
          if (safeStep === 4) {
            const shouldShowDetailedForm = !!(
              aboutForm?.noGoogleListing === true ||
              (placeDetails?.businessName &&
                !secureStorage.get("googleListing", ""))
            );
            if (shouldShowDetailedForm) {
              setShowDetailedForm(true);
            }
          }

          setIsInitialized(true);
          return;
        }

        // No data, no mode — fresh start
        setIsInitialized(true);
        return;
      }

      // 🔄 RESUME MODE - Load from tracker
      try {
        const response = await getOnBoardingTracker({ userId, email });
        const tracker = response?.tracker;

        // Don't bail when the tracker is empty: a draft that selected
        // a category but never pressed Continue has no tracker rows
        // yet, but its state was restored into secureStorage from the
        // localStorage resume snapshot above — we still want to
        // rehydrate from that below.
        const details = Array.isArray(tracker?.details) ? tracker.details : [];

        const completed = details
          .map((d) => d.stepNo)
          .filter((s) => STEP_FLOW.includes(s));

        // Resume at the EXACT step the user was last on. currentStep is
        // persisted (and restored across reopen) by the resume snapshot,
        // so prefer it. Falling back to lastCompleted+1 was the bug that
        // pushed a draft sitting on step 1 straight to step 2.
        let resumeStep = 1;
        const savedStep = parseInt(secureStorage.get("currentStep", "0"), 10);
        if (savedStep >= 1 && savedStep <= totalSteps) {
          resumeStep = savedStep;
        } else if (completed.length > 0) {
          resumeStep = Math.min(Math.max(...completed) + 1, totalSteps);
        }

        // Step 5 (Language & Voice) only needs a business selected in
        // step 4 — a website is optional.
        const placeDetails = secureStorage.get("placeDetailsExtract", null);
        const aboutForm = secureStorage.get("aboutBusinessForm", {});

        const hasStep5Access = !!(
          placeDetails?.businessName ||
          secureStorage.get("displayBusinessName", "")
        );

        if (resumeStep === 5 && !hasStep5Access) {
          resumeStep = 4;
          secureStorage.set("currentStep", 4);
        }

        setStep(resumeStep);

        const currentSessionId = secureStorage.get(
          "currentAgentSessionId",
          null,
        );
        const lastSessionId = secureStorage.get("lastAgentSessionId", null);
        const sessionChanged =
          currentSessionId && currentSessionId !== lastSessionId;

        const sessionDisplayName = secureStorage.get("displayBusinessName", "");
        const sessionPlaceDetails = secureStorage.get(
          "placeDetailsExtract",
          null,
        );
        const sessionBusinessType = secureStorage.get("businessType", "");
        const hasSessionData =
          sessionDisplayName || sessionPlaceDetails || sessionBusinessType;

        if (!hasSessionData || !sessionChanged) {
          let mergedData = {};
          details.forEach((detail) => {
            if (detail.data) mergedData = { ...mergedData, ...detail.data };
          });
          setFormData((prev) => ({ ...prev, ...mergedData }));
          Object.entries(mergedData).forEach(([key, value]) => {
            secureStorage.set(key, value);
          });
        } else {
          const sessionData = {
            businessType: secureStorage.get("businessType", ""),
            businessSubtype: secureStorage.get("businessSubtype", ""),
            customBusiness: secureStorage.get("customBusiness", ""),
            displayBusinessName: sessionDisplayName,
            googleListing: secureStorage.get("googleListing", ""),
            noGoogleListing: aboutForm.noGoogleListing || false,
            businessUrl: secureStorage.get("businessUrl", ""),
            noBusinessWebsite: aboutForm.noBusinessWebsite || false,
            placeDetails: sessionPlaceDetails,
            sitemapUrls: secureStorage.get("urls", []),
            selectedSitemapUrls: secureStorage.get("selectedSiteMapUrls", []),
            agentLanguage: secureStorage.get(
              "agentLanguage",
              defaultLanguage().name,
            ),
            agentLanguageCode: secureStorage.get(
              "agentLanguageCode",
              defaultLanguage().locale,
            ),
            agentRole: secureStorage.get("agentRole", "General Receptionist"),
            agentName: secureStorage.get("agentName", randomAgentName),
            customGreeting: secureStorage.get("customGreeting", ""),
            greetingChoice: secureStorage.get("greetingChoice", 0),
            customGreetingText: secureStorage.get("customGreetingText", ""),
          };

          const cleanedData = Object.fromEntries(
            Object.entries(sessionData).filter(([_, v]) => {
              if (v === null || v === undefined || v === "") return false;
              if (Array.isArray(v) && v.length === 0) return false;
              return true;
            }),
          );
          setFormData((prev) => ({ ...prev, ...cleanedData }));
        }

        // ✅ Resume mode mein bhi showDetailedForm restore
        if (resumeStep === 4) {
          const shouldShowDetailedForm = !!(
            aboutForm?.noGoogleListing === true ||
            (placeDetails?.businessName &&
              !secureStorage.get("googleListing", ""))
          );
          if (shouldShowDetailedForm) {
            setShowDetailedForm(true);
          }
        }

        setCompletedSteps(completed);
      } catch (error) {
        console.error("❌ Failed to load tracker:", error);
      } finally {
        setIsInitialized(true);
      }
    };

    loadData();
  }, [userId, email]);

  /*
   * Persist the resume point to localStorage on every change.
   *
   * secureStorage already holds the live onboarding state, but it dies on
   * app reopen (sessionStorage). We mirror the relevant keys + the current
   * route to localStorage so "Continue Setup" can later reopen the exact
   * screen the user left from, with their selections restored. Runs only
   * after init so we never overwrite the snapshot with an empty pre-hydrate
   * state.
   */
  useEffect(() => {
    if (!isInitialized) return;
    // Pounce ka adhoora onboarding receptionist ke "Continue setup" draft
    // jaisa na dikhe — iska resume snapshot likhte hi nahi.
    if (isPounceFlow) return;
    try {
      const keys = {};
      ONBOARDING_RESUME_KEYS.forEach((k) => {
        const v = secureStorage.get(k, undefined);
        if (v !== undefined && v !== null) keys[k] = v;
      });
      keys.currentStep = step;
      saveResumeRoute("/business-step");
      saveResumeSnapshot({ route: "/business-step", keys });
    } catch (_e) {
      /* best effort */
    }
  }, [formData, step, isInitialized]);
  /* ==========================================
       FETCH TIMEZONE WHEN STATE IS AVAILABLE
    ========================================== */

  const fetchAgentCountFromUser = async () => {
    // Deliberately does NOT touch the shared `loading` flag. `loading` gates
    // the Continue button (isContinueDisabled), and this mount-time agent
    // -count fetch is unrelated to step validation. Earlier it set
    // loading=true here, which left Continue faded on step 1 until this
    // network call finished — even after a category was already picked.
    try {
      // Was listAgents(): that endpoint returns EVERY user's agents as full
      // rows (no userId filter server-side) and we filtered in the browser —
      // which is why landing here sat for ~5-8s before bouncing to
      // /fast-agent-detail. This one is an indexed COUNT scoped to the
      // logged-in user via JWT — the same call resolveHomeRoute uses to pick
      // the post-login landing, so the two now agree by construction.
      const { count = 0 } = await getAgentsByUserIdforkey();
      setAgentCount(count);

      // Pounce user ke paas pehle se agent hota hi hai (More menu se aaya hai),
      // aur Create se aaya user jaan-boojh ke ek aur agent bana raha hai —
      // dono ke liye ye redirect onboarding me ghusne hi na deta.
      if (count >= 1 && !isPounceFlow && !isAddingAgent) {
        navigate("/fast-agent-detail");
        return;
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAgentCountFromUser();
    // localStorage.removeItem("allPlans")
    // sessionStorage.removeItem("checkPage")
  }, []);

  //
  useEffect(() => {
    const fetchTimezone = async () => {
      const placeDetails =
        formData.placeDetails || secureStorage.get("placeDetailsExtract", {});
      const state = placeDetails?.state || placeDetails?.state_code;

      if (!state || timezone) return;

      // console.log(" Fetching timezone for state:", state);

      try {
        const timezoneData = await getTimezoneFromState(state);

        if (timezoneData?.timezoneId) {
          setTimezone(timezoneData);
          secureStorage.set("timezone", timezoneData);
          // console.log(" Timezone fetched:", timezoneData.timezoneId);
        } else {
          // console.warn(" Timezone fetch returned no data");
          setTimezone(null);
        }
      } catch (error) {
        console.error(" Failed to fetch timezone:", error);
        setTimezone(null);
      }
    };

    fetchTimezone();
  }, [formData.placeDetails?.state, formData.placeDetails?.state_code]);

  /* ==========================================
       UPDATE FORM DATA
    ========================================== */
  const updateFormData = (updates) => {
    if ("isGMBSelected" in updates && updates.isGMBSelected === true) {
      modalConfirmedRef.current = false;
      justSelectedGMBRef.current = true;
    }
    setFormData((prev) => {
      const newData = { ...prev, ...updates };

      Object.entries(updates).forEach(([key, value]) => {
        if (value === null || value === undefined || value === "") {
          secureStorage.remove(key);
        } else {
          secureStorage.set(key, value);
        }
      });

      if (updates.placeDetails) {
        secureStorage.set("placeDetailsExtract", updates.placeDetails);
      }

      if (updates.selectedSitemapUrls) {
        secureStorage.set("selectedSiteMapUrls", updates.selectedSitemapUrls);
      }

      // console.log(" Updated formData:", { ...prev, ...updates });

      return newData;
    });
  };

  // Business email is optional, but if provided it must be a valid address
  // and within the length limit. Returns an error string, or "" when valid.
  const validateBusinessEmail = (email) => {
    const v = String(email || "").trim();
    if (v === "") return ""; // optional — empty is allowed
    if (v.length > BUSINESS_EMAIL_MAX_LENGTH) {
      return `Business email must be ${BUSINESS_EMAIL_MAX_LENGTH} characters or less`;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(v)) return "Please enter a valid email address";
    return "";
  };

  // Clear the inline email error whenever the confirm popup closes, so a
  // stale message doesn't reappear the next time it opens.
  useEffect(() => {
    if (!isModalOpen) {
      setConfirmEmailError("");
      setOpenTip(null);
    }
  }, [isModalOpen]);

  const updateBusinessEmail = (email) => {
    const businessEmail = String(email || "").slice(
      0,
      BUSINESS_EMAIL_MAX_LENGTH,
    );
    updateFormData({
      businessEmail,
      placeDetails: {
        ...(formData.placeDetails || {}),
        email: businessEmail,
      },
    });
  };

  /* ==========================================
     CLEAR STEP 2 & 3 DATA (SILENT RESET)
    ========================================== */
  const clearDownstreamSteps = async (fromStep) => {
    // console.log(` Clearing data from step ${fromStep + 1} onwards`);

    // REORDERED FLOW: business details are now captured in step 1 — BEFORE the
    // category step — so changing the category must NOT wipe them (that was the
    // "business details empty in createAgent" bug). The old fromStep<=1 block
    // that cleared displayBusinessName / placeDetails / businessUrl / sitemap +
    // their secureStorage keys is intentionally removed. Only the downstream
    // language/tone reset below still applies.

    if (fromStep <= 2) {
      updateFormData({
        agentLanguage: defaultLanguage().name,
        agentLanguageCode: defaultLanguage().locale,
        agentRole: "General Receptionist",
      });
    }

    const newCompleted = completedSteps.filter((s) => s <= fromStep);
    setCompletedSteps(newCompleted);
  };

  /* ==========================================
       SAVE STEP TO TRACKER
    ========================================== */
  const saveStep = async (stepNo, stepName, screenName) => {
    // Onboarding tracker receptionist ka 1:1 record hai — Pounce ka naya
    // business usme likhne se wo purana data overwrite ho jaata.
    if (isPounceFlow) return;
    await trackStep({
      stepName,
      stepNo,
      screenName,
      email,
      userId,
      data: formData,
      agentId: formData.agentId || null,
      flowType: "simple",
    });
  };

  /* ==========================================
       VALIDATION
    ========================================== */
  // `overrides` lets a caller validate against state it has just queued but
  // that hasn't re-rendered the step component yet (see handleContinue's
  // forceNoWebsite). Steps that don't understand it simply ignore the arg.
  const validateCurrentStep = async (overrides = {}) => {
    const refs = {
      1: stepPhoneLookupRef,
      2: stepNameZipRef,
      3: stepCategoryRef,
      4: stepServicesRef,
      5: stepVoiceRef,
    };
    const ref = refs[step];

    if (!ref?.current?.validate) return true;

    const result = await ref.current.validate(overrides);

    if (result === true) return true;

    const errorLabels = {
      googleListing: "Business Selection",
      businessName: "Business Name",
      phone: "Phone Number",
      address: "Address",
      businessUrl: "Website URL",
      email: "Business Email",
    };

    if (result?.errors) {
      const emailError = result.errors.email;

      const requiredFields = Object.keys(result.errors)
        .filter((key) => key !== "email" && result.errors[key])
        .map((key) => errorLabels[key] || key);

      let message = "";

      if (requiredFields.length > 0 && emailError) {
        message = `Required fields missing: ${requiredFields.join(" | ")}\nBusiness Email: ${emailError}`;
      } else if (requiredFields.length > 0) {
        message = `Required fields missing: ${requiredFields.join(" | ")}`;
      } else if (emailError) {
        message = emailError;
      } else {
        message = "Please complete all required fields";
      }

      setShowPopup(true);
      setPopupType("failed");
      setPopupMessage(message);
    } else {
      setShowPopup(true);
      setPopupType("failed");
      setPopupMessage("Please complete all required fields");
    }

    return false;
  };

  /* ==========================================
        CHECK IF STEP HAS REQUIRED DATA
    ========================================== */
  const hasRequiredData = () => {
    if (step === 1) {
      if (formData.noGoogleListing) {
        const hasName = !!(
          formData.placeDetails?.businessName?.trim() ||
          formData.displayBusinessName?.trim()
        );
        const hasPhone = !!(
          formData.placeDetails?.phone?.trim() || formData.businessPhone?.trim()
        );
        const hasAddress = !!(
          formData.placeDetails?.address?.trim() || formData.address?.trim()
        );
        return hasName && hasPhone && hasAddress;
      }
      return !!formData.placeDetails?.placeId;
    }
    if (step === 2) {
      return (
        (formData.placeDetails?.businessName?.trim().length > 0 ||
          formData.displayBusinessName?.trim().length > 0) &&
        (formData.placeDetails?.postal_code?.trim().length > 0 ||
          formData.zipCode?.trim().length > 0)
      );
    }
    if (step === 3) {
      return formData.businessType?.trim().length > 0;
    }
    if (step === 4) {
      if (!showDetailedForm) {
        if (formData.zipInvalid) return false;
        return formData.noGoogleListing || !!formData.zipLocation;
      } else {
        return formData.placeDetails?.businessName?.trim().length > 0;
      }
    }
    if (step === 5) {
      return true;
    }
    return false;
  };

  /* ==========================================
       STEP NAVIGATION WITH VALIDATION
    ========================================== */
  /*
   * TRUE jab category screen (step 3) is journey ka hissa NAHI hai.
   *
   * Ye flag SIRF us par hai jo ab tak SACH ME hua hai — "aage kya hoga" ka
   * andaza nahi lagata:
   *   • step 1 par abhi classification chali hi nahi, to pata hi nahi ki
   *     category screen aayegi ya nahi → default SKIPPED (2 dots).
   *   • step 3 par ek baar pahunch gaye → screen journey me hai (3 dots), aur
   *     ye ab peeche-aage jaane par badalta nahi.
   *
   * Teen galat versions ke baad yahan pahunche:
   *   1. `!formData.noBusinessWebsite` ("website hai to skip") — classify fail
   *      hone par jhooth bolta tha: 3 page dikhte the par dots 2.
   *   2. `categoryAutoPicked` — step 1 par wo abhi false hota hai, to pehli hi
   *      screen 3 dots dikhane lagti thi.
   *   3. `completedSteps.includes(3)` — peeche jaane par completedSteps trim
   *      ho jata hai, to category chun lene ke baad bhi dots 2 ho jate the.
   */
  /*
   * Sticky flag sirf tab likhta hai jab user step 3 par ho. Us ek lamhe se
   * chook jayen — purani session, ya user pehle se aage nikal chuka ho — to
   * reload par flag milta hi nahi aur dots wapas 2 ho jate hain.
   *
   * Isliye persisted state se bhi derive karte hain: category set hai PAR
   * categoryAutoPicked true nahi — matlab wo auto-pick se nahi aayi, user ne
   * screen par khud chuni thi. (goToStep step 3 par jate waqt
   * categoryAutoPicked hata deta hai, isliye ye sach rehta hai.)
   */
  const categoryPickedManually =
    !!String(secureStorage.get("businessType") || "").trim() &&
    secureStorage.get("categoryAutoPicked", false) !== true;

  const isCategorySkipped = !(
    step === 3 ||
    categoryScreenShown ||
    categoryPickedManually
  );

  // Category screen par pahunchte hi flag latch kar do — aur secureStorage me
  // bhi, taaki reload/resume par dots wapas 2 na ho jayen.
  useEffect(() => {
    if (step !== 3 || categoryScreenShown) return;
    setCategoryScreenShown(true);
    secureStorage.set("categoryScreenShown", true);
  }, [step, categoryScreenShown]);

  const goToStep = async (target, skipValidation = false) => {
    let finalTarget = target;

    if (finalTarget === 4) {
      finalTarget = step > 4 ? (isCategorySkipped ? 1 : 3) : 5;
    } else if (finalTarget === 2) {
      finalTarget = step > 2 ? 1 : 3;
    }

    if (finalTarget === 3) {
      secureStorage.remove("categoryAutoPicked");
    }

    if (
      isAnimating ||
      finalTarget === step ||
      finalTarget < 1 ||
      finalTarget > totalSteps
    )
      return;

    if (isProcessing) {
      setShowPopup(true);
      setPopupType("failed");
      setPopupMessage("Please wait for the current process to complete");
      return;
    }

    // Leaving step 4 → always drop the listing-confirm overlay.
    setShowListingConfirm(false);

    let updatedCompleted = [...completedSteps];
    if (finalTarget > step) {
      if (!skipValidation) {
        const isValid = await validateCurrentStep();
        if (!isValid) {
          return;
        }
      }

      if (!updatedCompleted.includes(step)) {
        updatedCompleted = [...updatedCompleted, step];
        setCompletedSteps(updatedCompleted);
      }
    }

    const requiredPredecessor = finalTarget - 1;
    if (requiredPredecessor === 2 || requiredPredecessor === 4) {
      const realPredecessor = requiredPredecessor === 2 ? 1 : 3;
      if (isCategorySkipped && realPredecessor === 3) {
        // Skip checking for Step 3 since it was bypassed
      } else if (!updatedCompleted.includes(realPredecessor)) {
        setShowPopup(true);
        setPopupType("failed");
        setPopupMessage(`Please complete Step ${realPredecessor} first`);
        return;
      }
    } else if (
      finalTarget > 1 &&
      !updatedCompleted.includes(requiredPredecessor)
    ) {
      setShowPopup(true);
      setPopupType("failed");
      setPopupMessage(`Please complete Step ${requiredPredecessor} first`);
      return;
    }

    if (finalTarget === 4) {
      setShowDetailedForm(false);
    }

    setDirection(finalTarget > step ? "forward" : "back");
    setNextStep(finalTarget);
    setIsAnimating(true);

    setTimeout(() => {
      setStep(finalTarget);
      setNextStep(null);
      setIsAnimating(false);
      secureStorage.set("currentStep", finalTarget);
    }, 700);
  };

  /* ==========================================
       BROWSER / PHONE BACK BUTTON HANDLING
       ------------------------------------------
       The whole onboarding lives on the single /business-step route, so a
       hardware/browser Back would otherwise leave the route entirely (back
       to /personal-details) even when the user is deep inside step 2's
       listing-confirm or manual-form sub-screens. We buffer a history entry
       and, on Back, peel off ONE internal screen at a time — only letting
       the browser truly navigate away once we're at the very first step.
    ========================================== */
  const navStateRef = useRef({
    step,
    showListingConfirm,
    showDetailedForm,
    isModalOpen,
    completedSteps,
    showPounceQualifying,
    showPouncePlan,
    showReceptionistPlan,
  });
  useEffect(() => {
    navStateRef.current = {
      step,
      showListingConfirm,
      showDetailedForm,
      isModalOpen,
      completedSteps,
      showPounceQualifying,
      showPouncePlan,
      showReceptionistPlan,
    };
  }, [
    step,
    showListingConfirm,
    showDetailedForm,
    isModalOpen,
    completedSteps,
    showPounceQualifying,
    showPouncePlan,
    showReceptionistPlan,
  ]);

  // Keep a live ref to goToStep so the once-bound popstate handler always
  // calls the latest closure (avoids stale `step`/`completedSteps`).
  const goToStepRef = useRef(goToStep);
  goToStepRef.current = goToStep;

  useEffect(() => {
    // Buffer entry so the first Back press fires popstate without leaving.
    window.history.pushState({ bsBackGuard: true }, "");
    const onPopState = () => {
      const {
        step: s,
        showListingConfirm: lc,
        showDetailedForm: df,
        isModalOpen: mo,
        completedSteps: done,
        showPounceQualifying: pq,
        showPouncePlan: pp,
        showReceptionistPlan: rp,
      } = navStateRef.current;
      // Plan screen pe Back dabaye to wapas qualifying questions screen pe
      if (pp) {
        setShowPouncePlan(false);
        secureStorage.remove("pouncePlanOpen");
        setShowPounceQualifying(true);
        secureStorage.set("pounceQualifyingOpen", true);
        window.history.pushState({ bsBackGuard: true }, "");
        return;
      }
      // Qualifying questions screen pe Back dabaye to step 5 — existing
      // business wale flow me step 5 hai hi nahi, wahan jahan se aaya tha.
      if (pq) {
        if (pounceExistingReturnTo) {
          exitPounceExisting();
          return;
        }
        setShowPounceQualifying(false);
        secureStorage.remove("pounceQualifyingOpen");
        window.history.pushState({ bsBackGuard: true }, "");
        return;
      }
      if (rp) {
        setShowReceptionistPlan(false);
        secureStorage.remove("receptionistPlanOpen");
        window.history.pushState({ bsBackGuard: true }, "");
        return;
      }
      /*
       * Confirm-details modal is the top-most screen → peel it first.
       * It used to be invisible to this handler, so Back moved the step
       * UNDERNEATH a modal that stayed open; its cross then ran
       * goToStep(2) as a no-op (already on 2) and teleported the user to
       * the listing screen. Mirror the cross's own behaviour instead.
       */
      if (mo) {
        setIsModalOpen(false);
        if (fromListingRef.current) {
          fromListingRef.current = false;
          goToStepRef.current?.(2);
          setShowListingConfirm(true); // back to the listing screen
        }
        window.history.pushState({ bsBackGuard: true }, "");
        return;
      }
      // Step 2 listing-confirm → back to the pin-code search view.
      if (lc) {
        setShowListingConfirm(false);
        window.history.pushState({ bsBackGuard: true }, "");
        return;
      }
      // Step 2 manual form → back to the pin-code search view.
      if (df) {
        setShowDetailedForm(false);
        window.history.pushState({ bsBackGuard: true }, "");
        return;
      }
      // Any later step → previous step (stays on the route).
      if (s > 1) {
        /*
         * Asli journey sirf ye hai: 1 → (3, agar category screen aayi) → 5.
         * Steps 2 aur 4 is flow me visit hote hi nahi, isliye `s - 1`
         * un par bhej deta hai aur goToStep ke remap par bharosa karna
         * padta hai — fragile.
         *
         * Pehle step 3 ka back `noBusinessWebsite || !businessUrl` par
         * decide hota tha. Wo signal ab galat hai: category screen
         * classification FAIL hone par bhi aati hai, jahan website
         * maujood hoti hai — us haalat me ye condition false hoti aur
         * back galat jagah chala jata.
         *
         * Ab mapping explicit hai, aur "category screen dikhi thi ya
         * nahi" ka faisla completedSteps se hota hai — wahi source jo
         * dots use karte hain.
         */
        const cameViaCategory = Array.isArray(done) && done.includes(3);
        const backTarget =
          s === 5 ? (cameViaCategory ? 3 : 1) : s === 4 ? 3 : 1; // steps 3 aur 2 dono ka pehla screen step 1 hi hai
        goToStepRef.current?.(backTarget);
        window.history.pushState({ bsBackGuard: true }, "");
        return;
      }
      /*
       * First step, nothing left to peel.
       *
       * App (native webview) me yahan "Exit App?" confirm dikhta hai —
       * kyunki wahan Back ka matlab poora app band karna hai.
       *
       * Web par aisa kuch nahi hota: browser Back sirf pichhle page pe
       * le jaata hai, to "Exit App?" popup galat hai. Isliye guard
       * dobara push NAHI karte — popstate already ek entry peel kar
       * chuka hai, so browser apne aap normal back kar leta hai.
       */
      if (!isNativeApp()) return;
      setShowExitModal(true);
      window.history.pushState({ bsBackGuard: true }, "");
    };
    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* ==========================================
       KEYBOARD-AWARE FOOTER (mobile)
       ------------------------------------------
       On mobile the footer (Continue button) is position:fixed at the bottom.
       When the on-screen keyboard opens inside the Android WebView the layout
       viewport doesn't shrink, so the footer would be hidden BEHIND the
       keyboard. We publish two CSS variables via the VisualViewport API:
         • `--kb-inset` — keyboard height; lifts the footer above the keyboard.
         • `--footer-h` — footer height; lets the scroll area end exactly at the
           footer's top edge so fields stay ABOVE the Continue button.
       The CSS does the layout; the browser handles focus-scrolling within the
       correctly-sized scroll area (no forced JS scrolling → no jank).
    ========================================== */
  const footerRef = useRef(null);

  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return; // older browsers — nothing to do
    const root = document.documentElement;
    const update = () => {
      // Pixels of the layout viewport currently covered by the keyboard.
      const inset = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
      root.style.setProperty("--kb-inset", `${inset}px`);
      if (footerRef.current) {
        root.style.setProperty(
          "--footer-h",
          `${footerRef.current.offsetHeight}px`,
        );
      }
    };
    vv.addEventListener("resize", update);
    vv.addEventListener("scroll", update);
    update();
    return () => {
      vv.removeEventListener("resize", update);
      vv.removeEventListener("scroll", update);
      root.style.removeProperty("--kb-inset");
      root.style.removeProperty("--footer-h");
    };
  }, []);

  // "Use this" on a Google Business Listing card → save it and jump to step 3.
  const handleListingSelected = async (listing) => {
    // The listing now carries the Google website (fetched in StepTwo). Use
    // it so the confirm modal's Website row isn't "N/A".
    const listingWebsite = (listing.website || "").trim();
    const hasWebsite = !!listingWebsite;
    // Google link for the picked listing — the payload's `googleListing`
    // (backend uses it as the business's Google URL). The autocomplete path
    // builds the same thing in StepTwo.handlePlaceSelect; without it the
    // "Use this" path shipped an empty googleListing.
    const listingGoogleLink = listing.name
      ? `https://www.google.com/search?q=${encodeURIComponent(`${listing.name} ${listing.address || ""}`.trim())}`
      : "";

    // GA4: user picked one of their Google Business Listings ("Use this").
    trackEvent("business_listing_selected", {
      business_name: listing.name || "",
      rating: listing.rating || "",
      reviews: listing.reviews || "",
      has_website: hasWebsite,
      city: listing.city || "",
      state: listing.state_code || listing.state || "",
    });
    // GA4: step-2 business details are finalized via the Google-listing path.
    // handleContinue (which fires this in the manual path) is bypassed here,
    // so fire it explicitly with source: google_listing.
    trackEvent("business_details_submit", {
      source: "google_listing",
      has_website: hasWebsite,
      business_name: listing.name || "",
      zip: formData.zipCode || "",
    });

    const details = {
      businessName: listing.name || "",
      address: listing.address || "",
      phone: listing.phone || "",
      internationalPhone: listing.phone || "",
      email: "",
      website: listingWebsite,
      rating: listing.rating || "",
      totalRatings: listing.reviews || "",
      // Opening hours ride along in `businessAddress` and end up in the
      // agent prompt. Google's hours when it has them, otherwise the same
      // 9-6 fallback the autocomplete path uses — an empty value made the
      // agent answer "hours: " with nothing.
      hours: listing.hours || DEFAULT_HOURS_STRING,
      businessStatus: "",
      categories: [],
      // Structured location — without these the business is saved with an
      // empty country/state/city, and the number-assign page can't
      // auto-fetch a phone number for the location (user had to add it
      // manually). Carried from the Google listing's address components.
      city: listing.city || "",
      state: listing.state || "",
      state_code: listing.state_code || "",
      country: listing.country || "",
      country_code: listing.country_code || "",
      postal_code: listing.postal_code || "",
    };
    updateFormData({
      placeDetails: details,
      displayBusinessName: listing.name || "",
      googleListing: listingGoogleLink,
      noGoogleListing: false,
      // Only mark "no website" when Google didn't return one.
      noBusinessWebsite: !hasWebsite,
      businessUrl: listingWebsite,
      // A "Use this" pick IS a Google-listing selection. Without this flag
      // handleContinue takes its "user typed a name but never picked a
      // listing" branch and WIPES placeDetails — that was the "edit the
      // details, press Continue, everything clears + required-field error"
      // bug.
      isGMBSelected: true,
    });
    // …but don't let that flag auto-open the confirm modal via the step-2
    // watcher: this flow opens the modal explicitly below, and the user can
    // come back to step 2 through the modal's Edit button — re-opening it
    // there would bounce them straight out of the form they just opened.
    justSelectedGMBRef.current = false;
    secureStorage.set("placeDetailsExtract", details);

    /*
     * Mirror the pick into the keys StepTwo rehydrates from.
     *
     * Edit (pencil) in the confirm modal sends the user back to step 2,
     * which unmounts/remounts StepTwo and resets its LOCAL state —
     * including `isUrlValid`. StepTwo restores "this URL is already
     * verified" from `aboutBusinessForm.businessUrl` + `websiteValidatedUrl`;
     * this path never wrote `aboutBusinessForm`, so the website showed in
     * the field while validation still treated it as unverified and blocked
     * Continue with "Provide a valid URL or check the box below."
     */
    if (listing.name) secureStorage.set("displayBusinessName", listing.name);
    if (listingGoogleLink)
      secureStorage.set("googleListing", listingGoogleLink);
    secureStorage.set("showNoGMBCheckbox", "true");
    try {
      const aboutForm = secureStorage.get("aboutBusinessForm", {});
      aboutForm.noGoogleListing = false;
      if (listingGoogleLink) aboutForm.googleListing = listingGoogleLink;
      if (hasWebsite) {
        aboutForm.businessUrl = listingWebsite;
        aboutForm.noBusinessWebsite = false;
      } else {
        delete aboutForm.businessUrl;
        aboutForm.noBusinessWebsite = true;
      }
      secureStorage.set("aboutBusinessForm", aboutForm);
    } catch (_e) {
      /* secureStorage soft-fails */
    }

    // Open the confirm modal IMMEDIATELY (over step 3) so the user gets
    // instant feedback on "Use this". While the website sitemap is being
    // fetched in the background, the modal shows a shimmer skeleton.
    setShowListingConfirm(false);
    fromListingRef.current = true; // so the modal's cross returns to step 2
    goToStep(3, true); // move to step 3 (data set → skip validation)
    setIsModalOpen(true); // show the confirm popup over step 3

    if (hasWebsite) {
      secureStorage.set("businessUrl", listingWebsite);
      secureStorage.set("websiteValidatedUrl", listingWebsite);

      // Fetch the website's sitemap so the agent is trained on the site's
      // pages. The normal GMB autocomplete flow does this inside
      // StepTwo.handleUrlVerification, but the "Use this" path skipped it
      // — leaving `urls` / `selectedSiteMapUrls` empty, so the website
      // knowledge base was never built for the new agent.
      setListingDetailsLoading(true); // shimmer ON
      try {
        const res = await listSiteMap(listingWebsite);
        let urls = res?.urls || [];
        if (!urls.includes(listingWebsite)) urls.unshift(listingWebsite);

        const pages = await filterCompanyPages(urls);
        const fp = Array.isArray(pages) ? pages : urls;
        const first10 = fp.slice(0, 10);
        const defaultSelected = first10.map((u) => ({
          url: u,
          checkedStatus: true,
        }));

        secureStorage.set("urls", first10);
        secureStorage.set("selectedSiteMapUrls", defaultSelected);
        secureStorage.set("selectedSiteMapUrls_backup", defaultSelected);
        secureStorage.set("viewSiteMap", true);
        updateFormData({
          sitemapUrls: first10,
          selectedSitemapUrls: defaultSelected,
        });
      } catch (e) {
        console.error("Sitemap fetch failed for selected listing:", e);
      } finally {
        setListingDetailsLoading(false); // shimmer OFF
      }
    }
  };

  // "Enter manually" footer → ask for confirmation first (popup).
  const handleEnterManually = () => {
    setShowManualConfirm(true);
  };

  // "Continue Manually" inside the popup → actually switch to the manual form.
  // Start the manual form with everything Google gave us dropped — the listing
  // wasn't theirs — but KEEP the business name they typed themselves. Wiping
  // it too meant the user retyped the same name they had just entered on the
  // previous screen (StepTwo's own manual-entry button already keeps it; the
  // two paths disagreeing was the bug).
  const confirmManualEntry = () => {
    // GA4: user skipped the Google listings and chose manual entry
    // (confirmed via the popup on the listing-confirm screen).
    trackEvent("business_listing_manual_entry", {
      source: "listing_confirm",
    });
    setShowManualConfirm(false);
    setShowListingConfirm(false);
    setShowDetailedForm(true);

    const typedName = (formData.displayBusinessName || "").trim();
    const clearedDetails = {
      businessName: typedName,
      address: "",
      phone: "",
      internationalPhone: "",
      email: "",
      website: "",
      rating: "",
      totalRatings: "",
      hours: [],
      businessStatus: "",
      categories: [],
    };
    updateFormData({
      noGoogleListing: true,
      isGMBSelected: false,
      displayBusinessName: typedName,
      googleListing: "",
      businessUrl: "",
      noBusinessWebsite: false,
      placeDetails: clearedDetails,
    });

    secureStorage.set("placeDetailsExtract", clearedDetails);
    if (typedName) secureStorage.set("displayBusinessName", typedName);
    else secureStorage.remove("displayBusinessName");
    secureStorage.remove("googleListing");
    secureStorage.remove("businessUrl");
    secureStorage.remove("websiteValidatedUrl");
    try {
      const aboutForm = secureStorage.get("aboutBusinessForm", {});
      aboutForm.noGoogleListing = true;
      aboutForm.noBusinessWebsite = false;
      delete aboutForm.googleListing;
      delete aboutForm.businessUrl;
      secureStorage.set("aboutBusinessForm", aboutForm);
    } catch (_e) {
      /* secureStorage soft-fails */
    }
  };

  const getFirst4ServicesByBusinessType = (businessType) => {
    const matched = businessServices.find((item) => item.type === businessType);

    if (!matched || !Array.isArray(matched.services)) return [];

    return matched.services.slice(0, 4) || [];
  };

  ///getSessionData
  const getSessionData = (key, defaultValue = null) => {
    const data = sessionStorage.getItem(key);

    if (!data) return defaultValue;

    try {
      return typeof data === "string" ? JSON.parse(data) : data;
    } catch (e) {
      console.error(`Error parsing ${key}:`, e);
      return defaultValue;
    }
  };
  const ownerDetails = getSessionData("OwnerDetails", {});

  const ownerName = ownerDetails?.name || "";
  /* ==========================================
       BUILD FINAL PAYLOAD
    ========================================== */
  // Where THIS agent is built. A Pounce agent was always a Node/Retell agent,
  // since only Retell could dial out. Python now dials too (Node's
  // services/pythonOutbound.js), so with REACT_APP_POUNCE_ON_PYTHON=true a
  // Python account's Pounce agent is built on Python as well.
  const pounceOnPython = isPounceFlow && process.env.REACT_APP_POUNCE_ON_PYTHON === "true";
  const agentOnPython = () => isPythonBackend() && (!isPounceFlow || pounceOnPython);

  const buildFinalPayload = () => {
    const placeDetails =
      firstNonEmpty(
        secureStorage.get("placeDetailsExtract", {}),
        formData.placeDetails,
      ) || {};
    // Python flow (rexpt.in / port 3001): Python backend khud website crawl,
    // 10-URL selection aur scraping handle karta hai — use sirf businessWebsite
    // chahiye. Is liye sitemap URLs khaali bhejo (frontend crawl ka result nahi).
    const selectedSitemapUrls = agentOnPython()
      ? []
      : firstNonEmpty(
          secureStorage.get("selectedSiteMapUrls", []),
          formData.selectedSitemapUrls,
        ) || [];
    const storedTimezone = secureStorage.get("timezone", null) || timezone;

    // Funnel A: if the visitor paid via the LP popup, Thankyou2
    // stashed the purchased plan slug ("starter" / "scaler" / "growth")
    // in localStorage. Stamp it on the new agent so the backend
    // assigns the paid tier instead of the legacy "free" default,
    // which is what triggers the in-app upsell prompts.
    const paidPlan = localStorage.getItem("paidPlan") || "";
    const planForAgent = paidPlan ? paidPlan : "free";

    // Platform-based agent type: when the app is running inside the native
    // React Native WebView wrapper (Android or iOS), create the new
    // "Sales Receptionist" agent type instead of the default. Plain web
    // browsers keep the existing General Receptionist / selected role.
    //
    // Python backend is excluded from that: "Sales Receptionist" only exists
    // as a template under the shared "default" industry (promptTemplates.js),
    // so build_prompt() falls back to it for EVERY business type and the 55
    // industry-specific templates never get used. A Python agent therefore
    // keeps its selected role, which resolves to its own business category's
    // prompt. Node/Retell agents are untouched.
    // India (.in) also creates a Sales Receptionist, with ONE exception: an
    // AppSumo signup keeps its selected role. An AppSumo buyer has already
    // paid on AppSumo's checkout, so the sales script — which exists to sell
    // the $20 trial and the monthly plans — has nothing to sell them.
    //
    // KNOWN TRADE-OFF: "Sales Receptionist" exists only under the shared
    // "default" industry (1 of 55), so build_prompt() falls back to it for
    // EVERY business type — a bakery and a plumber get the same generic sales
    // prompt, and their industry-specific templates are not used. That is the
    // accepted cost of this decision; giving India industry-aware sales
    // agents means adding a Sales Receptionist template per industry in
    // promptTemplates.js.

    
    const platform = detectPlatform();
    const isNativeApp =
      platform === "android" || platform === "ios" || platform === "web";
    // Pre-paid naya agent: sales script usi plan ko bechne ke liye hai jo
    // khareeda ja chuka hai — aur plan jodne wala createAgent claim Sales →
    // General switch nahi karta, to agent hamesha sales prompt pe atka rehta.
    // Naya .ai account (voiceEngine = python) bhi Sales Receptionist paata hai,
    // jaise Retell par paata tha — Python me pura sales flow hai (sales tools,
    // go-live par General Receptionist me flip). Bahar sirf purane India /
    // AppSumo jaise Python accounts rehte hain, jinke liye upar wala note hai.
    // usesElevenLabs() = python account aur India site nahi.
    const wantsSalesAgent =
      isNativeApp &&
      (!isPythonBackend() || usesElevenLabs()) &&
      !isIndiaSite() &&
      !isAppSumoUser() &&
      !paidForNewAgentRef.current;
    // Pounce: backend agentType ko hi agentRole me save karta hai, aur
    // pounceService.resolvePounceAgent() agentRole = 'pounce' dhoondhta hai.
    // Sales Receptionist wala override Pounce pe nahi lagna chahiye.
    const resolvedAgentType = isPounceFlow
      ? "pounce"
      : wantsSalesAgent
        ? "Sales Receptionist"
        : formData.agentRole || "General Receptionist";

    /*
     * Greeting ka intent jo DB me jaata hai:
     *   "default" — koi line pin nahi; customGreeting khaali jaati hai aur
     *               backend prompt me apni teen natural variations daal deta hai.
     *   "custom"  — user ki apni line, jo customGreeting me jaati hai.
     * Custom select kiya par likha kuch nahi → wo default hi hai.
     */
    const resolvedGreetingChoice =
      formData.greetingChoice === "custom" &&
      String(formData.customGreetingText || "").trim()
        ? "custom"
        : "default";

    const payload = {
      agentName: "Agent",
      corePurpose: formData.businessType || "",
      industry: formData.businessType || "",
      service: getFirst4ServicesByBusinessType(formData.businessType),
      businessName:
        placeDetails.businessName || formData.displayBusinessName || "",
      agentType: resolvedAgentType,
      agentLanguage: formData.agentLanguage || "English (US)",
      userId: userId,
      agentVoice: "11labs-Cimo",
      agentLanguageCode: formData.agentLanguageCode || defaultLanguage().locale,
      businessPhone:
        placeDetails.internationalPhone || placeDetails.phone || "",
      businessEmail: placeDetails.email || "",
      customServices: [],
      agentGender: "female",
      agentAvatar: randomAgentAvatar,
      timeZoneId: storedTimezone?.timezoneId || "",
      agentAccent: "american",
      businessAddress: JSON.stringify({ addressDetails: placeDetails || null }),
      plan: planForAgent,
      // Was hardcoded false — all-party-consent states never got the declaration.
      callRecording: requiresCallRecording(
        placeDetails.state,
        placeDetails.state_code,
      ),
      agentNote: "",
      languageAccToPlan: formData.agentLanguage || "English (US)",
      businessWebsite: formData.businessUrl || "",
      googleBusinessName: formData.displayBusinessName || "",
      googleListing: formData.googleListing || "",
      // Python case me sitemap URLs khaali — Python backend khud crawl karta hai.
      sitemapUrls: agentOnPython() ? [] : formData.sitemapUrls || [],
      selectedSitemapUrls: selectedSitemapUrls,
      isQuickSetup: false,
      isMinutesSet: false,
      isBusinessSubType:
        formData.businessSubtype || formData.businessSubtype || "",
      country_code: placeDetails.country_code || "",
      state_code: placeDetails.state_code || "",
      isPromptGeneration: false,
      agentName: randomAgentName,
      agentCreationType: "fast",
      ownerName: ownerDetails?.name,
      // Screen 5 pe select ki gayi greeting. StepThree hamesha resolved line
      // formData me rakhta hai (custom khaali ho to pehla pre-built variant),
      // aur backend ise createAgent me prompt ke Greeting block me daal deta
      // hai — see promptService.generatePrompt / getGreetingSection.
      customGreeting: formData.customGreeting || "",
      greetingChoice: resolvedGreetingChoice,
      // Plan screen ki choice aur qualifying questions.
      ...(isPounceFlow
        ? {
            pouncePlan: secureStorage.get("pouncePlan", "payg"),
            pounceOnboardingId: secureStorage.get("pounceOnboardingId", ""),
            qualifyingQuestions: secureStorage.get(
              "pounceQualifyingQuestions",
              DEFAULT_POUNCE_QUALIFYING_QUESTIONS,
            ),
          }
        : {}),
    };

    return payload;
  };

  /* ==========================================
       HANDLE CONTINUE
    ========================================== */
  /*
   * `opts.forceNoWebsite` — the Continue handler auto-ticks "I do not have a
   * Business website" when the user has details but left the URL empty. That
   * setState hasn't reached StepTwo's props by the time we validate here, so
   * the intent has to travel as an argument; otherwise the first click
   * validated against the stale value and rejected with a website error
   * (a second click then "mysteriously" worked).
   */
  const handleContinue = async (opts = {}) => {
    if (isProcessing) return;

    const forceNoWebsite = opts.forceNoWebsite === true;

    setIsProcessing(true);

    try {
      const isValid = await validateCurrentStep(
        forceNoWebsite ? { noBusinessWebsite: true } : {},
      );
      if (!isValid) {
        if (step === 4 && !showDetailedForm) {
          setShowDetailedForm(true);
          setShowPopup(true);
          setPopupType("failed");
          setPopupMessage(
            "Some business details are missing or invalid. Please review the highlighted fields below.",
          );
        }
        setIsProcessing(false);
        return;
      }

      /*
       * GA4: Continue confirmed.
       *
       * Ye block pehle handleContinue ke SABSE UPAR tha — validation se
       * pehle. Isliye galat/adhoore data ke saath Continue dabane par bhi
       * `*_confirmed` event chala jata tha, jabki step pass hua hi nahi.
       * Ab ye `isValid` guard ke BAAD hai, to "confirmed" ka matlab sach
       * me confirmed hai.
       *
       * Step 1 (StepPhoneLookup) yahan se koi event nahi bhejta — wo apne
       * hi `business_phone_confirmed` + `business_details_step1_continue`
       * fire karta hai (StepPhoneLookup.validate me). Pehle yahan step 1
       * par `businessname_zipcode_entered_confirmed` bhi jata tha, jo us
       * screen ka event hai hi nahi (wahan zip field hi nahi hai, to zip
       * hamesha khaali jata tha) — hata diya gaya.
       */
      if (step === 2) {
        trackEvent("businessname_zipcode_entered_confirmed", {
          business_name:
            formData.displayBusinessName ||
            formData.placeDetails?.businessName ||
            "",
          zip: formData.zipCode || "",
        });
      } else if (step === 3) {
        trackEvent("businesscategory_selected_confirmed", {
          category: formData.businessType || "",
          subtype: formData.businessSubtype || "",
        });
      } else if (step === 4) {
        trackEvent("business_details_submit", {
          source: formData.isGMBSelected ? "google_listing" : "manual",
          has_website: !!formData.businessUrl,
          business_name:
            formData.displayBusinessName ||
            formData.placeDetails?.businessName ||
            "",
          zip: formData.zipCode || "",
        });
      } else if (step === 5) {
        trackEvent("language_tonestyle_selected_confirmed", {
          language: formData.agentLanguage || "",
          tone_style: formData.agentRole || "",
        });
      }

      const stepConfig = {
        1: { name: "Phone Lookup", screen: "PhoneLookup" },
        2: { name: "Business Details", screen: "NameZipDetails" },
        3: { name: "Business Type", screen: "BusinessTypeSelection" },
        4: { name: "Business Search", screen: "GoogleBusinessListing" },
        5: { name: "Language & Voice", screen: "LanguageVoiceSelection" },
      };

      await saveStep(step, stepConfig[step].name, stepConfig[step].screen);

      if (step === 1) {
        setIsProcessing(false);
        /*
         * Category screen dikhani hai ya skip karni hai — ye faisla ab
         * "category SACH ME mili ya nahi" par hota hai, "website hai ya
         * nahi" par nahi.
         *
         * Pehle sirf noBusinessWebsite dekha jata tha. Website hone par
         * screen hamesha skip ho jati thi — chahe auto-pick poori tarah
         * fail ho gaya ho. Aise me StepPhoneLookup chupchaap
         * "E-commerce" set kar deta tha aur user ka agent galat category
         * par ban jata tha, bina use bataye. Ab fail hone par category
         * khaali rehti hai (autoPickCategory → clearAutoCategory) aur
         * user ko screen milti hai.
         *
         * secureStorage se padhte hain, formData se nahi: StepPhoneLookup
         * ki validate() abhi-abhi updateFields() kar ke aayi hai aur wo
         * state update async hai — is closure ka formData purana hoga.
         * secureStorage usi waqt synchronously likh diya jata hai.
         */
        const pickedCategory = String(
          secureStorage.get("businessType") || "",
        ).trim();
        // Category screen ek baar journey ka hissa ban gayi to wahi
        // rasta rehta hai — dots bhi 3 dikha rahe hote hain, to Continue
        // ka use skip kar dena user ko dot 2 se uchhal kar dot 3 par
        // pahuncha deta, jo galat lagta hai. Wahan category pehle se
        // bhari hoti hai, user seedha Continue daba sakta hai.
        const categoryStepInJourney =
          categoryScreenShown || categoryPickedManually;
        goToStep(pickedCategory && !categoryStepInJourney ? 5 : 3);
        return;
      }
      if (step === 2) {
        setIsProcessing(false);
        goToStep(3);
        return;
      }
      if (step === 3) {
        setUserProperties({ business_category: formData.businessType || "" });
        setIsProcessing(false);
        goToStep(5);
        return;
      }

      if (!completedSteps.includes(step)) {
        setCompletedSteps((prev) => [...prev, step]);
      }
      if (step === 4) {
        if (!formData.noGoogleListing && formData.isGMBSelected) {
          const hasRealDetails = !!(
            formData.placeDetails?.businessName &&
            formData.placeDetails?.phone &&
            formData.placeDetails?.address
          );

          if (hasRealDetails) {
            setIsProcessing(false);
            goToStep(5);
            return;
          }
        }

        // ✅ Random text dala ya GMB select nahi kiya
        if (!formData.noGoogleListing && !formData.isGMBSelected) {
          const typedName = formData.displayBusinessName || "";

          const clearedDetails = {
            businessName: typedName,
            address: "",
            phone: "",
            internationalPhone: "",
            email: "",
            website: "",
            rating: "",
            totalRatings: "",
            hours: [],
            businessStatus: "",
            categories: [],
          };

          updateFormData({
            placeDetails: clearedDetails,
            displayBusinessName: typedName,
            noGoogleListing: true,
            noBusinessWebsite: false, // ✅ false rakho
            businessUrl: "",
            isGMBSelected: false,
          });

          secureStorage.set("placeDetailsExtract", clearedDetails);
          if (typedName) secureStorage.set("displayBusinessName", typedName);
          else secureStorage.remove("displayBusinessName");
          secureStorage.remove("businessUrl");
          secureStorage.remove("websiteValidatedUrl");
          secureStorage.remove("selectedSiteMapUrls");
          secureStorage.remove("selectedSiteMapUrls_backup");
          secureStorage.remove("urls");
          secureStorage.set("viewSiteMap", false);

          const aboutForm = secureStorage.get("aboutBusinessForm", {});
          aboutForm.noGoogleListing = true;
          aboutForm.noBusinessWebsite = false; // ✅ false rakho
          delete aboutForm.googleListing;
          delete aboutForm.businessUrl;
          secureStorage.set("aboutBusinessForm", aboutForm);

          setShowDetailedForm(true);
          setIsProcessing(false);
          return;
        }

        // ✅ noGoogleListing true hai — validate karo pehle, phir step 5
        if (formData.noGoogleListing) {
          // ✅ Manually fields check karo
          const hasBusinessName = !!(
            formData.placeDetails?.businessName || formData.displayBusinessName
          );
          const hasPhone = !!formData.placeDetails?.phone;
          const hasAddress = !!formData.placeDetails?.address;
          // forceNoWebsite: the caller ticked "no website" a tick ago —
          // formData hasn't caught up, so honour the intent here too.
          const hasWebsite =
            forceNoWebsite ||
            formData.noBusinessWebsite ||
            !!formData.businessUrl;

          if (!hasBusinessName || !hasPhone || !hasAddress || !hasWebsite) {
            // ✅ Fields empty hain — showDetailedForm pe raho, error dikhao
            setShowDetailedForm(true);
            setShowPopup(true);
            setPopupType("failed");
            setPopupMessage(
              "Please fill all required fields before continuing.",
            );
            setIsProcessing(false);
            return;
          }
          if (!hasWebsite) {
            updateFormData({ noBusinessWebsite: true });
            const aboutForm = secureStorage.get("aboutBusinessForm", {});
            aboutForm.noBusinessWebsite = true;
            delete aboutForm.businessUrl;
            secureStorage.set("aboutBusinessForm", aboutForm);
            secureStorage.remove("businessUrl");
          }

          // ✅ Sab fields filled hain — step 5 pe jao
          setIsProcessing(false);
          goToStep(5);
          return;
        }
      }
      if (step === totalSteps) {
        // Pounce: agent banne se pehle qualifying questions -> plan + card.
        if (
          isPounceFlow &&
          !opts.pounceBillingDone &&
          secureStorage.get("pouncePaidDone", false) !== true
        ) {
          openPounceQualifying(true);
          return;
        }
        // Ek aur receptionist (user ke paas pehle se agent hai): pehle plan +
        // payment. Payment ke baad Stripe `?paidNewAgent=1` ke saath lautata
        // hai aur neeche wala effect isi function ko `receptionistPaid` ke
        // saath chalata hai. Python / India / AppSumo ke apne plan-rules
        // hain — unka flow pehle jaisa rehta hai.
        // Naya .ai Python account (usesElevenLabs) bhi Retell jaisa: doosra
        // receptionist pehle plan + payment. Plan jodna Node ka hi kaam hai
        // (updateAgentSubscription, sirf DB), to Python agent pe bhi waise hi.
        const needsPaidAddAgent =
          !isPounceFlow &&
          isAddingAgent &&
          (Number(agentCount) || 0) >= 1 &&
          (!isPythonBackend() || usesElevenLabs()) &&
          !isIndiaSite() &&
          !isAppSumoUser();
        // Payment pehle hi ho chuka par agent banne me error aaya tha → user
        // dobara Continue dabaye to phir se payment screen NAHI (double charge).
        const alreadyPaid =
          opts.receptionistPaid ||
          secureStorage.get("newAgentPaid", false) === true;
        if (needsPaidAddAgent && !alreadyPaid) {
          openReceptionistPlan(true);
          return;
        }
        if (alreadyPaid) {
          paidForNewAgentRef.current = true;
          secureStorage.set("newAgentPaid", true);
        }
        const finalPayload = buildFinalPayload();
        // New .ai account → Python agent that speaks through ElevenLabs. The
        // payload still carries a Retell voice name, so the Python service
        // picks a real ElevenLabs voice for the agent's gender.
        if (usesElevenLabs() && agentOnPython()) finalPayload.ttsProvider = "elevenlabs";
        // Clover onboarding: user Clover se redirect ho kar aaya tha to
        // success page pe `fromClover` flag session me set hua. Backend ko
        // bhejo taaki wo SIRF is case me naye agent ko Clover integration
        // (agent_ids) se link kare — har user pe DB lookup na ho.
        if (sessionStorage.getItem("fromClover") === "1") {
          finalPayload.fromClover = "1";
        }
        try {
          trackEvent("agent_build_start");
          // Stamp build start so the ready screen can report build_seconds.
          sessionStorage.setItem("agentBuildStart", String(Date.now()));
          setLoading(true);
          setIsCreatingAgent(true);
          // Backend switch ab utils/apiBackend.js se (ek jagah logic).
          // Pounce on Retell → Node, with the login token Node expects.
          const pounceOnNode = isPounceFlow && !agentOnPython();
          const createAgentUrl = pounceOnNode
            ? `${process.env.REACT_APP_API_BASE_URL}/agentV2/createAgent`
            : pyOrNodeUrl("/agents", "/agentV2/createAgent");
          const res = await axios.post(createAgentUrl, finalPayload, {
            headers: pounceOnNode
              ? {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
                }
              : authHeaders(),
          });
          //Create Chat Agent

          const placeDetails =
            firstNonEmpty(
              secureStorage.get("placeDetailsExtract", {}),
              formData.placeDetails,
            ) || {};
          const selectedSitemapUrls =
            firstNonEmpty(
              secureStorage.get("selectedSiteMapUrls", []),
              formData.selectedSitemapUrls,
            ) || [];
          const storedTimezone =
            secureStorage.get("timezone", null) || timezone;
          const payload = {
            // Industry & Role
            industryKey: formData.businessType || "",
            industry: formData.businessType || "",
            corePurpose: formData.businessType || "",
            roleTitle: formData.agentRole || "General Receptionist",

            // Agent Info
            agentName: randomAgentName,
            agentGender: "female",
            agentAvatar: randomAgentAvatar,
            agentType: formData.agentRole || "General Receptionist",
            agentVoice: "11labs-Cimo",
            agentAccent: "american",
            agentCreationType: "fast",

            // Language
            languageSelect: formData.agentLanguage || "English (US)",
            agentLanguage: formData.agentLanguage || "English (US)",
            agentLanguageCode:
              formData.agentLanguageCode || defaultLanguage().locale,
            languageAccToPlan: formData.agentLanguage || "English (US)",

            // Business Info
            business: {
              businessName:
                placeDetails.businessName || formData.displayBusinessName || "",
              email: placeDetails.email || "",
            },
            businessName:
              placeDetails.businessName || formData.displayBusinessName || "",
            businessPhone:
              placeDetails.internationalPhone || placeDetails.phone || "",
            businessEmail: placeDetails.email || "",
            businessAddress: JSON.stringify({
              addressDetails: placeDetails || null,
            }),
            businessWebsite: formData.businessUrl || "",

            // Google / Location
            googleBusinessName: formData.displayBusinessName || "",
            googleListing: formData.googleListing || "",
            country_code: placeDetails.country_code || "",
            state_code: placeDetails.state_code || "",

            // Services
            service: getFirst4ServicesByBusinessType(formData.businessType),
            customServices: [],

            // Sitemap
            sitemapUrls: formData.sitemapUrls || [],
            selectedSitemapUrls: selectedSitemapUrls,

            // Plan & Settings

            // Misc / Flags
            userId: userId,
            timeZone: storedTimezone?.timezoneId,
            timeZoneId: storedTimezone?.timezoneId || "",

            knowledgeBaseId: sessionStorage.getItem("knowledgeBaseId"),

            // Sub-type & Generation Flags
            isBusinessSubType: formData.businessSubtype || "",
            isQuickSetup: false,
            isMinutesSet: false,
            isPromptGeneration: false,

            // Agent ID (from response)
            agent_id: res?.data?.data?.agent_id,
            ownerName: ownerDetails?.name,
          };
          // Python flow (rexpt.in / port 3001): createChatAgent SKIP —
          // Python backend pe ye endpoint nahi hai, aur web call ab
          // /fast-step pe Python WebSocket se hoti hai (Retell nahi).
          // Pounce outbound caller hai — website chat agent ki zaroorat nahi.
          if (!isPythonBackend() && !isPounceFlow) {
            const response = await createChatAgent(payload, token);
          }
          // Pounce agent ko "selected agent" mat banao — warna Home pe user ko
          // uske receptionist ki jagah Pounce agent ka dashboard dikhta.
          if (!isPounceFlow) {
            sessionStorage.setItem(
              "SelectAgentBusinessId",
              res?.data?.data?.businessId,
            );
            sessionStorage.setItem("SelectAgentId", res?.data?.data?.agent_id);
            // A Pounce agent made earlier in this session left "pounce" here;
            // paired with the new receptionist's id it made the agent page and
            // its plan / number checks treat the receptionist as Pounce.
            sessionStorage.removeItem("SelectAgentRole");
            localStorage.removeItem("SelectAgentRole");
          }

          // ── Clover onboarding done → flag hatao ──
          // Agent ban gaya aur backend ne agent_id integration_config me
          // link kar diya. Ab `fromClover` ki zaroorat nahi — hata do taaki
          // isi session me agar dobara agent bane to fizool ka lookup na ho.
          sessionStorage.removeItem("fromClover");
          sessionStorage.removeItem("cloverMerchantId");

          // ── Clear onboardingMode after agent is created successfully ──
          sessionStorage.removeItem("onboardingMode");
          // Agent ban gaya — "naya agent" intent poora, redirect wapas normal.
          sessionStorage.removeItem("addingAgent");
          // Agent created — the draft is done, so discard the
          // persisted resume backup so it can't reopen later.
          clearOnboardingResume();

          // Node flow: web-call access token yahin le lete hain (Retell
          // auto-call ke liye). Python flow me web call /fast-step pe
          // Python WebSocket se hoti hai — koi token pehle se nahi chahiye,
          // is liye create-web-call SKIP.
          let accessToken = "";
          let callId = "";
          let transport = "";
          let iceServers = [];
          // Pounce ka test call "send a test lead" step pe hota hai (outbound),
          // receptionist wali inbound web call nahi.
          if (!isPythonBackend() && !isPounceFlow) {
            const callRes = await fetch(
              `${process.env.REACT_APP_API_BASE_URL}/agent/create-web-call`,
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                // rexpt_test_call: owner ki apni test call — backend live-monitoring push skip karta hai
                body: JSON.stringify({ agent_id: res?.data?.data?.agent_id, metadata: { rexpt_test_call: "true" } }),
              },
            );

            if (callRes.status === 403) {
              if (res?.data?.data?.agentPlan === "free") {
                alert(
                  "Your Agent Plan has been exhausted. To continue, please upgrade your plan.",
                );
              } else {
                alert(
                  "Your Agent Plan has been exhausted. To continue, please enable Pay As You Go.",
                );
              }
              setLoading(false);
              return;
            }
            const callData = await callRes.json();
            accessToken = callData.access_token;
            callId = callData.call_id;
            transport = callData.transport;
            iceServers = callData.ice_servers;
            sessionStorage.setItem("autoCallAccessToken", accessToken);
            sessionStorage.setItem("autoCallCallId", callId);
            sessionStorage.setItem("autoCallTransport", callData.transport || "");
            sessionStorage.setItem("autoCallIceServers", JSON.stringify(callData.ice_servers || []));
          }
          sessionStorage.setItem("isAgentCreated", "true");

          // Setup Score: Retell agent pe businessConfirmed backend ka createAgent
          // mark karta hai, par Python agent /py/agents se banta hai jahan ye
          // mark hota hi nahi tha — free user ka progress 0% pe atka rehta tha.
          if (agentOnPython()) {
            markSetupStep("businessConfirmed");
          }

          // Funnel A handoff: visitors that paid through the LP
          // popup have already cleared the See Plans / Recommended
          // Plan upsell screens, so we drop them straight on
          // /go-live-setup (the same screen the normal Stripe
          // success_url would redirect to). The flags are
          // single-use — clear them here so a later in-app
          // signup/upgrade by the same browser doesn't accidentally
          // re-trigger this branch with a stale plan.
          const fromLp = localStorage.getItem("fromLp") === "true";
          const paymentAlreadyDone =
            localStorage.getItem("paymentDone") === "true";
          // Skip the See Plans / Recommended Plan upsell screens
          // for anyone who has already paid — both LP (Funnel A)
          // visitors and users with paymentDone latched from a
          // prior checkout. Both groups drop straight onto
          // /go-live-setup, same as the Stripe success_url.
          const skipPaymentScreens = fromLp || paymentAlreadyDone;
          const newAgentId = res?.data?.data?.agent_id || "";
          // GoLiveWizard reads agentId/userId off the query
          // string (its checkout-return path), so mirror them
          // there for the skip branch. /fast-step doesn't read
          // search params, only location.state.
          const goLivePath = `/go-live-setup?agentId=${encodeURIComponent(newAgentId)}&userId=${encodeURIComponent(userId || "")}`;
          // Pounce agent banne ke baad seedha dashboard — number screen
          // (/receptionist-number) beech me nahi. Number baad me Pounce agent
          // detail ke "Assign Number" se lagta hai.
          // Pre-paid naya receptionist → /go-live-setup, wahi screen jahan har
          // paid checkout ke baad user jaata hai (plan link confirm, number).
          const target = isPounceFlow
            ? "/dashboard"
            : skipPaymentScreens || paidForNewAgentRef.current
              ? goLivePath
              : "/fast-step";
          if (paidForNewAgentRef.current) {
            // Agent ban gaya — payment isi agent ka ho gaya, flags saaf.
            secureStorage.remove("receptionistPlanOpen");
            secureStorage.remove("newAgentPaid");
          }
          if (isPounceFlow) {
            // Plan screen ki choice agent pe save — dashboard card isi se
            // P-A-Y-G / Subscription dikhata hai. Fail ho to bhi agent ban
            // chuka hai, isliye flow nahi rokte (card PAYG default dikhayega).
            try {
              await savePouncePlan(
                newAgentId,
                secureStorage.get("pouncePlan", "payg"),
              );
            } catch (e) {
              console.warn("[Pounce] plan save failed:", e?.message || e);
            }
            // Flow poora — flags saaf, taaki agla onboarding receptionist ho.
            sessionStorage.removeItem("onboardingFlow");
            secureStorage.remove("pouncePlanOpen");
            secureStorage.remove("pouncePlan");
            secureStorage.remove("pounceOnboardingId");
            secureStorage.remove("pouncePaidDone");
            secureStorage.remove("pounceQualifyingOpen");
            secureStorage.remove("pounceQualifyingQuestions");
            sessionStorage.removeItem("pounceExistingReturnTo");
          }
          // LP ke flags receptionist checkout ke hain — Pounce unhe na khaaye.
          if (fromLp && !isPounceFlow) {
            localStorage.removeItem("fromLp");
            localStorage.removeItem("paidPlan");
          }

          const continueToSetup = () => {
            // Returning within the SPA must not reuse the pre-creation list.
            useDashboardStore.getState().setHasFetched(false);
            if (isPounceFlow) {
              sessionStorage.setItem("SelectAgentId", newAgentId);
              sessionStorage.setItem("SelectAgentBusinessId", res?.data?.data?.businessId || "");
              sessionStorage.setItem("SelectAgentRole", "pounce");
            }
            navigate(target, {
              state: {
                agentId: newAgentId,
                businessId: res?.data?.data?.businessId,
                accessToken: accessToken,
                callId: callId,
                fromPounce: isPounceFlow,
                transport: transport,
                iceServers: iceServers,
              },
              replace: true,
            });
          };

          if (agentOnPython()) {
            // Python skips Retell's slow createChatAgent + create-web-call
            // awaits, so the agent is ready almost instantly. In Retell the
            // "Agent created" popup lands right when the loader card's points
            // finish ticking (its slow awaits take about that long). Reproduce
            // that exactly: wait until the card's 4 points have all ticked, then
            // show the popup — same moment as Retell — hold 1.3s so it's
            // visible, then navigate.
            //
            // Points finish at stepDelay × steps = 900ms × 4 = 3600ms after the
            // card opened (agentBuildStart). NOT the 6000ms min-display floor —
            // that left the card sitting fully-ticked for ~2.4s before the popup.
            const CARD_POINTS_DONE_MS = 900 * 4; // stepDelay × checklist points
            const buildStart =
              Number(sessionStorage.getItem("agentBuildStart")) || Date.now();
            const navDelay = Math.max(
              100,
              CARD_POINTS_DONE_MS - (Date.now() - buildStart),
            );
            setTimeout(() => {
              setShowPopup(true);
              setPopupType("success");
              setPopupMessage("Agent created successfully!");
              setTimeout(continueToSetup, 1300);
            }, navDelay);
          } else {
            // Retell — EXACTLY as before: popup shows immediately, navigate
            // fires 100ms later (the gap lets the popup render before the page
            // is replaced). Do not change this path.
            setTimeout(continueToSetup, 100);
            setShowPopup(true);
            setPopupType("success");
            setPopupMessage("Agent created successfully!");
          }
        } catch (error) {
          console.error(
            " Failed to create agent:",
            error?.response?.data || error,
          );

          setShowPopup(true);
          setPopupType("failed");
          setPopupMessage("Failed to create agent. Please try again.");
        } finally {
          setLoading(false);
          setIsCreatingAgent(false);
          setIsProcessing(false);
        }

        return;
      }

      goToStep(step + 1);
    } finally {
      setIsProcessing(false);
    }
  };

  /* ==========================================
       RENDER STEPS
    ========================================== */
  const renderStep = (s) => {
    if (s === 1) {
      return (
        <StepPhoneLookup
          ref={stepPhoneLookupRef}
          data={formData}
          updateFields={updateFormData}
          onNext={() => goToStep(3)}
          onSkip={() => goToStep(2)}
        />
      );
    }

    if (s === 2) {
      return (
        <StepNameZip
          ref={stepNameZipRef}
          data={formData}
          updateFields={updateFormData}
        />
      );
    }

    if (s === 3) {
      return (
        <StepOne
          ref={stepCategoryRef}
          data={formData}
          updateData={updateFormData}
          setIsFocused={setIsFocused}
          onBusinessTypeChange={clearDownstreamSteps}
        />
      );
    }

    if (s === 4) {
      return (
        <StepTwo
          ref={stepServicesRef}
          data={formData}
          updateFields={updateFormData}
          showDetailedForm={showDetailedForm}
          setShowDetailedForm={setShowDetailedForm}
          setLoading={setLoading}
          setIsProcessing={setIsProcessing}
          showListingConfirm={showListingConfirm}
          onUseListing={handleListingSelected}
        />
      );
    }

    if (s === 5) {
      return (
        <StepThree
          ref={stepVoiceRef}
          data={formData}
          updateData={updateFormData}
          styles={styles}
        />
      );
    }
  };
  useEffect(() => {
    // Pounce user ke paas uska receptionist agent selected hai (SelectAgentId).
    // Use rehne do — Pounce ke baad Home pe wahi khulna chahiye — aur uski
    // wajah se Finish button bhi band mat karo.
    if (isPounceFlow) {
      setIsAgentAlreadyCreated(false);
      return;
    }
    // Starting a BRAND-NEW agent (Create → mode "new") must ignore any
    // previously-selected agent left in session. Otherwise the Finish button
    // is wrongly disabled ("Agent already created") — e.g. an admin who was
    // just viewing an owner's agent (SelectAgentId set) can't create their
    // OWN agent. Clear the stale selection so the create flow starts fresh.
    if (location.state?.mode === "new") {
      sessionStorage.removeItem("SelectAgentId");
      sessionStorage.removeItem("SelectAgentBusinessId");
      sessionStorage.removeItem("SelectAgentOwnerId");
      setIsAgentAlreadyCreated(false);
      return;
    }
    const existingAgentId = sessionStorage.getItem("SelectAgentId");
    if (existingAgentId) {
      setIsAgentAlreadyCreated(true);
    }
  }, []);

  useEffect(() => {
    if (!justSelectedGMBRef.current) return;
    if (step !== 4) return;
    if (formData.noGoogleListing) return;
    if (isModalOpen) return;
    if (isProcessing) return;

    const hasRealDetails = !!(
      formData.placeDetails?.businessName &&
      formData.placeDetails?.phone &&
      formData.placeDetails?.address
    );

    if (hasRealDetails) {
      justSelectedGMBRef.current = false;
      setIsModalOpen(true);
    }
  }, [
    formData.placeDetails?.businessName,
    formData.placeDetails?.phone,
    formData.placeDetails?.address,
    isProcessing,
    step,
  ]);
  /*
   * Stripe se wapas — plan ka payment ho gaya, ab agent banao.
   *
   * Do raaste yahan aate hain, dono `?paidNewAgent=1` ke saath:
   *   • embedded checkout: CheckoutSheet SPA-navigate karta hai; ye component
   *     mounted hi rehta hai, sirf location.search badalta hai
   *   • hosted checkout: success_url pe poora page reload; step 5 aur baaki
   *     data secureStorage se wapas aata hai
   * Ref guard isliye ki effect dobara chale (step / init badle) to agent do
   * baar na bane.
   */
  const paidReturnHandledRef = useRef(false);
  useEffect(() => {
    if (!isInitialized || paidReturnHandledRef.current) return;
    const params = new URLSearchParams(location.search);
    if (params.get("paidNewAgent") !== "1") return;
    if (step !== totalSteps) return; // step restore hote hi dobara chalega
    paidReturnHandledRef.current = true;
    // URL saaf — refresh pe ye dobara na chale.
    window.history.replaceState(window.history.state, "", location.pathname);
    openReceptionistPlan(false);
    handleContinue({ receptionistPaid: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized, location.search, step]);

  useEffect(() => {
    if (!isInitialized) return;
    const params = new URLSearchParams(location.search);
    if (params.get("pouncePaid") !== "1") return;
    if (step !== totalSteps) return;
    window.history.replaceState(window.history.state, "", location.pathname);
    // Plan screen khuli rahe to creation loader aur error popup dikhte hi nahi.
    openPouncePlan(false);
    // Agent banne me error aaye to retry pe dobara checkout nahi.
    secureStorage.set("pouncePaidDone", true);
    handleContinue({ pounceBillingDone: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized, location.search, step]);

  // const isContinueDisabled = loading || isProcessing || !hasRequiredData();
  const isContinueDisabled =
    loading ||
    isProcessing ||
    !hasRequiredData() ||
    (step === totalSteps && isAgentAlreadyCreated);

  useEffect(() => {
    const handleKeyDown = (e) => {
      // Plan screen ke apne buttons hain — Enter yahan step 5 ka Continue na chalaye.
      if (showPouncePlan || showReceptionistPlan) return;
      if (e.key === "Enter" && !isContinueDisabled && !isProcessing) {
        e.preventDefault();

        // Step 4 simple view + zip picked → open listing confirmation.
        if (
          step === 4 &&
          !showDetailedForm &&
          !showListingConfirm &&
          formData.zipLocation
        ) {
          setShowListingConfirm(true);
          return;
        }
        if (showListingConfirm) return; // listing screen has its own actions

        if (step === 4 && !formData.placeDetails) {
          setShowDetailedForm(true);
          updateFormData({ noGoogleListing: false });
          const aboutForm = secureStorage.get("aboutBusinessForm", {});
          aboutForm.noGoogleListing = false;
          secureStorage.set("aboutBusinessForm", aboutForm);
          return;
        }

        handleContinue();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [
    step,
    isContinueDisabled,
    isProcessing,
    formData.placeDetails,
    showListingConfirm,
    formData.zipLocation,
    showPouncePlan,
    showReceptionistPlan,
  ]);

  // Map logical steps (1 to 5) to progress dots (dynamically 2 or 3).
  // isCategorySkipped upar ek hi jagah define hai — dots aur goToStep dono
  // wahi flag padhte hain, warna do jagah alag sach ban jata tha.
  const getActiveDot = () => {
    if (isCategorySkipped) {
      if (step === 1) return 1;
      if (step === 5) return 2;
      return 2;
    } else {
      if (step === 1) return 1;
      if (step === 3) return 2;
      if (step === 5) return 3;
      return 3;
    }
  };
  const activeDot = getActiveDot();

  const handleDotClick = (targetDot) => {
    if (isCategorySkipped) {
      if (targetDot === 1) {
        goToStep(1);
      } else if (targetDot === 2) {
        goToStep(5);
      }
    } else {
      if (targetDot === 1) {
        goToStep(1);
      } else if (targetDot === 2) {
        goToStep(3);
      } else if (targetDot === 3) {
        if (completedSteps.includes(3)) {
          goToStep(5);
        } else {
          goToStep(3);
        }
      }
    }
  };

  if (!isInitialized) {
    return <div className={styles.loader}>Loading...</div>;
  }

  // Ek aur receptionist: step 5 ke baad, agent banne se pehle — plan + payment.
  if (!isPounceFlow && showReceptionistPlan) {
    return (
      <NewAgentPlanScreen
        onBack={() => openReceptionistPlan(false)}
        returnTo="/business-step"
      />
    );
  }

  // Pounce: step 5 ke baad, agent banne se pehle — pehle qualifying questions screen
  if (isPounceFlow && showPounceQualifying) {
    return (
      <PounceQualifyingQuestions
        initialQuestions={secureStorage.get(
          "pounceQualifyingQuestions",
          DEFAULT_POUNCE_QUALIFYING_QUESTIONS,
        )}
        onBack={() =>
          pounceExistingReturnTo
            ? exitPounceExisting()
            : openPounceQualifying(false)
        }
        busy={isProcessing}
        onContinue={async (questions) => {
          secureStorage.set("pounceQualifyingQuestions", questions);
          const businessId =
            sessionStorage.getItem("SelectAgentBusinessId") ||
            secureStorage.get("businessId", "") ||
            "";
          // Already paid for this business (checkout link sent to the
          // customer): no plan screen, no checkout — the agent is created and
          // linked to that subscription by its setup id.
          setIsProcessing(true);
          const paid = businessId ? await findPaidPounceSetup(businessId) : null;
          setIsProcessing(false);
          openPounceQualifying(false);
          if (paid) {
            secureStorage.set("pounceOnboardingId", paid.onboardingId);
            secureStorage.set("pouncePlan", paid.plan);
            secureStorage.set("pouncePaidDone", true);
            handleContinue({ pounceBillingDone: true });
            return;
          }
          openPouncePlan(true);
        }}
      />
    );
  }

  // Pounce: qualifying questions ke baad — plan + card screen
  if (isPounceFlow && showPouncePlan) {
    return (
      <PouncePlanScreen
        initialPlan={secureStorage.get("pouncePlan", "payg")}
        onPlanChange={(plan) => secureStorage.set("pouncePlan", plan)}
        onBack={() => {
          openPouncePlan(false);
          openPounceQualifying(true);
        }}
        busy={isProcessing}
        onContinue={async ({ plan, deal }) => {
          secureStorage.set("pouncePlan", plan);

          const businessId =
            sessionStorage.getItem("SelectAgentBusinessId") ||
            secureStorage.get("businessId", "") ||
            "";

          if (!businessId) {
            openPouncePlan(false);
            handleContinue({ pounceBillingDone: true });
            return;
          }

          setIsProcessing(true);
          try {
            const successUrl = `${window.location.origin}${window.location.pathname}?pouncePaid=1`;
            const cancelUrl = `${window.location.origin}${window.location.pathname}`;
            let onboardingId = secureStorage.get("pounceOnboardingId", "");
            if (!onboardingId) {
              onboardingId = window.crypto.randomUUID();
              secureStorage.set("pounceOnboardingId", onboardingId);
            }
            const result = await startPounceCheckout({
              businessId,
              onboardingId,
              plan,
              successUrl,
              cancelUrl,
            });

            if (result?.clientSecret) {
              // Existing business: plan screen ke neeche business steps nahi
              // dikhne chahiye — card sheet band kare to plan pe hi rahe.
              if (!pounceExistingReturnTo) openPouncePlan(false);
              useCheckoutStore.getState().openCheckout({
                clientSecret: result.clientSecret,
                sessionId: result.sessionId,
                hostedUrl: result.checkoutUrl || null,
                meta: {
                  next: window.location.pathname,
                  extraParams: { pouncePaid: "1" },
                  product: "pounce",
                  planName: plan === "subscribe" ? "Pounce Subscribe" : "Pounce Pay As You Go",
                  // Special lead deal: the trial strip shows its terms.
                  // A deal with trialDays 0 has no trial: the sheet hides the strip.
                  ...(deal?.trialDays === 0
                    ? { noTrial: true }
                    : deal
                      ? {
                          trialHeadline: `${deal.trialLeads} free new leads or ${deal.trialDays} days`,
                          trialNote: `Your free trial ends after ${deal.trialLeads} new leads or ${deal.trialDays} days,`,
                        }
                      : {}),
                },
              });
              return;
            }

            if (result?.checkoutUrl) {
              window.location.replace(result.checkoutUrl);
              return;
            }

            throw new Error("Stripe did not return a checkout session. Please try again.");
          } catch (error) {
            console.error("[Pounce] checkout start failed:", error);
            openPouncePlan(false);
            setPopupType("failed");
            setPopupMessage(error.message || "We couldn't start your free trial. Please try again.");
            setShowPopup(true);
          } finally {
            setIsProcessing(false);
          }
        }}
      />
    );
  }

  return (
    <>
      <div className={styles.containerBox}>
        {/* SLIDE STAGE */}
        <div
          className={styles.stage}
          style={{
            pointerEvents: isProcessing ? "none" : "auto",
            opacity: isProcessing ? 0.6 : 1,
            transition: "opacity 0.3s ease",
          }}
        >
          <div
            className={`${styles.container}
                            ${isAnimating ? (direction === "forward" ? styles.exitLeft : styles.exitRight) : ""}
                        `}
          >
            {renderStep(step)}
          </div>

          {isAnimating && nextStep && (
            <div
              className={`${styles.container} ${direction === "forward" ? styles.enterRight : styles.enterLeft}`}
            >
              {renderStep(nextStep)}
            </div>
          )}
        </div>

        {/* FOOTER */}
        <div ref={footerRef} className={styles.footer}>
          {/* Listing-confirm screen → swap the steps/Continue footer for
                        the "Can't find it? Enter manually" footer. */}
          {step === 4 && showListingConfirm ? (
            <>
              <div className={styles.orDivider}>
                <span>OR</span>
              </div>
              <div className={styles.manualFooterCard}>
                <div className={styles.manualFooterText}>
                  <p className={styles.manualFooterTitle}>Can't find it?</p>
                  <p className={styles.manualFooterSub}>
                    Enter details manually instead
                  </p>
                </div>
                <button
                  className={styles.manualFooterBtn}
                  onClick={handleEnterManually}
                  disabled={isProcessing}
                >
                  Enter manually
                  <img
                    className={styles.arrow}
                    src="/svg/arrow_2_new.svg"
                    alt=""
                  />
                </button>
              </div>
            </>
          ) : (
            <>
              {(step === 1 ||
                step === 2 ||
                step === 3 ||
                step === 4 ||
                step === 5) && (
                <div className={styles.TipDiv}>
                  <img src="/svg/tip_icon.svg" alt="tip_icon" />
                  <p className={styles.tipText}>
                    {step === 5 ? (
                      <>
                        <span className={styles.TipTitle}>Next:</span> Hear it
                        answer a real call
                      </>
                    ) : (
                      <>
                        <span className={styles.TipTitle}>Tip:</span> You can
                        update this later
                      </>
                    )}
                  </p>
                </div>
              )}

              <div className={styles.FooterNav}>
                <div className={styles.steps}>
                  {(isCategorySkipped ? [1, 2] : [1, 2, 3]).map((d) => (
                    <span
                      key={d}
                      onClick={() => !isProcessing && handleDotClick(d)}
                      className={`${styles.dot} ${activeDot === d ? styles.active : ""} ${isProcessing ? styles.disabled : ""}`}
                      style={{
                        cursor: isProcessing ? "not-allowed" : "pointer",
                        opacity: isProcessing ? 0.5 : 1,
                      }}
                    >
                      {activeDot === d ? d : ""}
                    </span>
                  ))}
                </div>

                <button
                  className={`${styles.continueBtn} ${isContinueDisabled ? styles.continueBtnDisabled : ""}`}
                  onClick={() => {
                    // Step 3 with no category chosen: slide-in error, don't proceed.
                    if (step === 3 && !formData.businessType?.trim()) {
                      triggerCategoryError();
                      return;
                    }
                    // Step 4 simple view: Business Name is mandatory — block and
                    // surface the inline error if it's empty.
                    if (
                      step === 4 &&
                      !showDetailedForm &&
                      !showListingConfirm
                    ) {
                      if (
                        stepServicesRef.current?.validateSimpleView?.() ===
                        false
                      ) {
                        return;
                      }
                      // GA4: Continue pressed on the name+zip simple view. Fire
                      // HERE (not only in handleContinue) because the Google-
                      // listing path opens a confirm screen and returns early,
                      // never reaching handleContinue. Covers both the listing
                      // and manual sub-paths; the one-shot guard dedupes the
                      // repeat that handleContinue would fire in the manual flow.
                      trackEvent("businessname_zipcode_entered_confirmed", {
                        business_name:
                          formData.displayBusinessName ||
                          formData.placeDetails?.businessName ||
                          "",
                        zip: formData.zipCode || "",
                      });
                    }
                    // Step 4 simple view + zip picked → open the Google
                    // Business Listing confirmation screen.
                    if (
                      step === 4 &&
                      !showDetailedForm &&
                      !showListingConfirm &&
                      formData.zipLocation
                    ) {
                      setShowListingConfirm(true);
                      return;
                    }
                    if (step === 2 && !formData.placeDetails) {
                      setShowDetailedForm(true);
                      updateFormData({ noGoogleListing: false });
                      const aboutForm = secureStorage.get(
                        "aboutBusinessForm",
                        {},
                      );
                      aboutForm.noGoogleListing = false;
                      secureStorage.set("aboutBusinessForm", aboutForm);
                      return;
                    }
                    if (
                      step === 2 &&
                      formData.placeDetails &&
                      !formData.businessUrl &&
                      !formData.noBusinessWebsite
                    ) {
                      updateFormData({ noBusinessWebsite: true });
                      const aboutForm = secureStorage.get(
                        "aboutBusinessForm",
                        {},
                      );
                      aboutForm.noBusinessWebsite = true;
                      delete aboutForm.businessUrl;
                      secureStorage.set("aboutBusinessForm", aboutForm);
                      secureStorage.remove("businessUrl");
                      // handleContinue bhi call karo taaki flow ruke na.
                      // Pass the intent — the updateFormData above
                      // hasn't re-rendered StepTwo yet, so without
                      // this the very first click failed validation
                      // on a website that we just marked absent.
                      handleContinue({ forceNoWebsite: true });
                      return;
                    }
                    handleContinue();
                  }}
                  // All steps: Continue is disabled until the step's required
                  // data is present — e.g. step 1 stays disabled until a
                  // business category is selected.
                  disabled={isContinueDisabled}
                  style={{
                    cursor: isContinueDisabled ? "not-allowed" : "pointer",
                  }}
                  title={
                    step === totalSteps && isAgentAlreadyCreated
                      ? "Agent already created"
                      : ""
                  } // ADD
                >
                  {isCreatingAgent
                    ? "Creating..."
                    : step === totalSteps
                      ? "Hear it live"
                      : "Continue"}
                  {!isCreatingAgent && (
                    <img
                      className={styles.arrow}
                      src="/svg/arrow_2.svg"
                      alt=""
                    />
                  )}
                </button>
              </div>
            </>
          )}
        </div>
      </div>

      {/* MODAL */}
      <NewModal
        isOpen={isModalOpen}
        onClose={() => {
          // GA4: user closed the confirm-details modal with the cross
          // (didn't press "Looks good").
          trackEvent("business_details_confirm_closed", {
            screen: "confirm_business_details",
          });
          /*
           * TheRRR listing flow opens this modal DURING goToStep(3)'s
           * 700ms slide. goToStep() no-ops while `isAnimating` (or
           * while processing), so closing here would swallow the
           * navigation and strand the user on step 3 with no modal
           * and no way back. Keep it open — a click a moment later
           * behaves normally.
           */
          if (fromListingRef.current && (isAnimating || isProcessing)) return;
          setIsModalOpen(false);
          // Opened from a "Use this" listing pick → cross goes back to step 2.
          if (fromListingRef.current) {
            fromListingRef.current = false;
            goToStep(2);
            setShowListingConfirm(true); // return to the listing screen
          }
        }}
        title="Confirm your business details"
        height="auto"
        bodyMaxHeight="90vh"
      >
        <div className={`${styles.confirmBox} ${styles.confirmBoxPlain}`}>
          <div className={styles.infoDiv}>
            <div className={styles.warningBox}>
              <img src="/svg/info_green.svg" alt="info_green" />
              <p>
                We'll use this information to <b>greet callers</b> and{" "}
                <b>answer basic questions.</b>
              </p>
            </div>
            <img
              onClick={() => {
                // GA4: user tapped the edit (pencil) icon on the
                // confirm-details modal to correct something.
                trackEvent("business_details_edit_click", {
                  screen: "confirm_business_details",
                });
                // Same guard as the cross: while the step-3 slide is
                // still running goToStep(2) is a no-op, and closing
                // the modal anyway would leave a blank step 3.
                if (fromListingRef.current && (isAnimating || isProcessing))
                  return;
                setIsModalOpen(false);
                // From listing flow we're on step 3 → drop back to step 2's
                // manual form. goToStep(2) resets showDetailedForm, so set
                // it true AFTER (last write wins).
                if (fromListingRef.current) {
                  fromListingRef.current = false;
                  setShowListingConfirm(false);
                  goToStep(2);
                  setShowDetailedForm(true);
                } else {
                  setShowDetailedForm(true);
                }
              }}
              src="/svg/edit-icon3.svg"
              alt="edit_icon"
            />
          </div>

          <div className={styles.confirmRow}>
            <span className={styles.introName}>Business Name</span>
            {(() => {
              if (listingDetailsLoading)
                return (
                  <span className={`${styles.skel} ${styles.skelValue}`} />
                );
              const name =
                formData.placeDetails?.businessName ||
                formData.displayBusinessName ||
                "N/A";
              const long = name.length > 20;
              if (!long)
                return <span className={styles.introDetail}>{name}</span>;
              return (
                <span
                  className={`${styles.introDetail} ${styles.tooltipCell} ${openTip === "name" ? styles.tooltipOpen : ""}`}
                  data-tooltip={name}
                  onClick={() => setOpenTip(openTip === "name" ? null : "name")}
                >
                  {truncateText(name, 20)}
                </span>
              );
            })()}
          </div>
          <div className={styles.confirmRow}>
            <span className={styles.introName}>Phone Number</span>
            {listingDetailsLoading ? (
              <span className={`${styles.skel} ${styles.skelValue}`} />
            ) : (
              <span className={styles.introDetail}>
                {formData.placeDetails?.phone || "N/A"}
              </span>
            )}
          </div>
          <div className={styles.confirmRow}>
            <span className={styles.introName}>City / location</span>
            {(() => {
              if (listingDetailsLoading)
                return (
                  <span className={`${styles.skel} ${styles.skelValue}`} />
                );
              const addr = formData.placeDetails?.address || "N/A";
              const long = addr.length > 20;
              if (!long)
                return <span className={styles.introDetail}>{addr}</span>;
              return (
                <span
                  className={`${styles.introDetail} ${styles.tooltipCell} ${openTip === "address" ? styles.tooltipOpen : ""}`}
                  data-tooltip={addr}
                  onClick={() =>
                    setOpenTip(openTip === "address" ? null : "address")
                  }
                >
                  {truncateText(addr, 20)}
                </span>
              );
            })()}
          </div>
          <div className={styles.confirmRow}>
            <span className={styles.introName}>Business Email</span>
            {listingDetailsLoading ? (
              <span className={`${styles.skel} ${styles.skelValue}`} />
            ) : (
              <input
                type="email"
                className={styles.inlineEmailInput}
                style={{
                  color: formData.placeDetails?.email ? "#24252C" : "#979797",
                }}
                placeholder="Add your email? (for notifications)"
                value={formData.placeDetails?.email || ""}
                maxLength={BUSINESS_EMAIL_MAX_LENGTH}
                onChange={(e) => {
                  const value = e.target.value.slice(
                    0,
                    BUSINESS_EMAIL_MAX_LENGTH,
                  );
                  updateFormData({
                    placeDetails: {
                      ...formData.placeDetails,
                      email: value,
                    },
                  });
                  // Live-validate so an invalid email is flagged immediately.
                  setConfirmEmailError(validateBusinessEmail(value));
                }}
                onBlur={(e) =>
                  setConfirmEmailError(validateBusinessEmail(e.target.value))
                }
              />
            )}
          </div>
          {confirmEmailError && (
            <p className={styles.errorText} style={{ marginTop: "-4px" }}>
              {confirmEmailError}
            </p>
          )}
          <div className={styles.confirmRow}>
            <span className={styles.introName}>Website</span>
            {listingDetailsLoading ? (
              <span className={`${styles.skel} ${styles.skelValue}`} />
            ) : (
              <span className={styles.introDetail}>
                {formData.businessUrl || "N/A"}
              </span>
            )}
          </div>

          <div className={styles.bothBtn}>
            <div className={styles.looksGoodBtn}>
              <AnimatedButton
                label="Looks good"
                positionType="relative"
                width="auto"
                onClick={async () => {
                  // Details abhi fetch ho rahi hain (shimmer) — confirm rok do.
                  if (listingDetailsLoading) return;
                  // Block confirmation if the entered Business Email is invalid.
                  const emailErr = validateBusinessEmail(
                    formData.placeDetails?.email,
                  );
                  if (emailErr) {
                    setConfirmEmailError(emailErr);
                    return;
                  }
                  // Listing "Use this" flow: we're already on step 3 with
                  // the picked details set — just confirm and close.
                  if (fromListingRef.current) {
                    fromListingRef.current = false;
                    trackEvent("business_details_confirmed");
                    modalConfirmedRef.current = true;
                    setIsModalOpen(false);
                    return;
                  }
                  setIsProcessing(true);
                  const result = await stepServicesRef.current?.validate();

                  if (result !== true) {
                    setIsProcessing(false);
                    const errors = result?.errors || {};
                    const errorKeys = Object.keys(errors);

                    if (errorKeys.length === 1 && errorKeys[0] === "email") {
                      setPopupType("failed");
                      setPopupMessage(
                        errors.email || "Please enter a valid Business Email.",
                      );
                      setShowPopup(true);
                      return;
                    }

                    setIsModalOpen(false);
                    setShowDetailedForm(true);
                    if (!formData.noGoogleListing) {
                      setShowPopup(true);
                      setPopupType("failed");
                      setPopupMessage("Please fix the validation errors");
                    }
                    return;
                  }
                  trackEvent("business_details_confirmed");
                  modalConfirmedRef.current = true;
                  setIsModalOpen(false);
                  setIsProcessing(false);
                  goToStep(3);
                }}
              />
            </div>
          </div>
        </div>
      </NewModal>

      {/* ENTER-MANUALLY CONFIRM POPUP */}
      <NewModal
        isOpen={showManualConfirm}
        onClose={() => setShowManualConfirm(false)}
        title="Enter business detail manually?"
        height="auto"
        bodyMaxHeight="90vh"
      >
        <div className={styles.manualConfirmBox}>
          <p className={styles.manualConfirmText}>
            Selecting your Google Business Profile can save time by filling your
            address, phone, website, and hours automatically.
          </p>
          <button
            className={styles.manualConfirmBtn}
            onClick={confirmManualEntry}
          >
            Continue Manually
          </button>
        </div>
      </NewModal>

      {/* POPUP */}
      {showPopup && (
        <PopUp
          type={popupType}
          message={popupMessage}
          onClose={() => {
            setShowPopup(false);
            setAutoClosePopup(false);
          }}
        />
      )}

      {/* Slide-in error toast (right → left), auto-hides after ~2.8s. Kept
                mounted so the CSS transition plays on the way out too. */}
      <div
        className={`${styles.errorToast} ${categoryError ? styles.errorToastShow : ""}`}
        role="alert"
        aria-live="assertive"
      >
        <span className={styles.errorToastDot} />
        Please select a category first.
      </div>

      {/* AGENT CREATION LOADER — popup overlay with blurred backdrop (Figma 8a) */}
      <AgentCreationLoader
        isOpen={isCreatingAgent}
        bizName={
          formData.placeDetails?.businessName ||
          formData.displayBusinessName ||
          formData.businessName ||
          ""
        }
        minDisplayMs={6000} // ← 3000, 7000, etc.
        stepDelay={900}
      />

      {/* EXIT APP CONFIRMATION MODAL */}
      <ExitConfirmModal
        open={showExitModal}
        title="Exit App?"
        body="Are you sure you want to exit? Your progress will be saved as a draft."
        stayLabel="Keep setting up"
        leaveLabel="Exit App"
        onStay={() => {
          setShowExitModal(false);
          window.history.pushState({ bsBackGuard: true }, "");
        }}
        onLeave={() => {
          setShowExitModal(false);
          if (typeof window !== "undefined" && window.ReactNativeWebView) {
            try {
              window.ReactNativeWebView.postMessage(
                JSON.stringify({ type: "EXIT_APP" }),
              );
            } catch (_e) {
              window.history.back();
            }
          } else {
            window.history.back();
          }
        }}
      />
    </>
  );
};

export default BusinessStep;
